const API_URL = "https://api.evisnailart.hu/api";
// v2.0
import React, { useState, useEffect, useRef, useCallback } from "react";

// -------------------------------------------------------
//  EVI'S NAIL ART - ROZSA TEMA (Francia luxus rozsakert)
//  Paletta: krem, mely bordo, arany, rozsa
// -------------------------------------------------------

const V = {
  cream:  "#fdfaf6",   // krem hatter
  ivory:  "#f5efe6",   // elefantcsont
  warm:   "#ede4d8",   // meleg bezs
  blush:  "#f0d5d5",   // halvany rozsa
  rose:   "#c0445a",   // mely rozsa
  bud:    "#e8728a",   // nyilo rozsa
  petal:  "#f2a0b0",   // sziromszin
  dark:   "#2a1a1e",   // mely sotet
  deep:   "#4a1a28",   // mely bordo
  gold:   "#b8924a",   // antik arany
  muted:  "#9a8070",   // meleg szurke
  border: "rgba(192,68,90,.14)",
  sage:   "#6b8f6b",   // halvany zsalya zold
  mint:   "#4a7c59",   // mely menta zold
  leafbg: "rgba(107,143,107,.1)", // zold hatter
};

const PRODS = [
  { id:"p1", group:"Elegancia", slug:"black-marble-noir",    name:"Black Marble Noir",     price:4990, compare:null, badge:"Uj",        stock:12, sub:"Márvány  ·  Arany akcentek", bg:"linear-gradient(135deg,#1c1512,#3a2820)", e:"heart", sizes:["XS","S","M","L","XL"], shape:"Mandula",   finish:"Fenyes",    desc:"Szürke-fehér márvány minták finom aranyozással. Időtlen elegancia, modern kontraszttal. 24 db press-on köröm tapasszal és reszelővel." },
  { id:"p2", group:"Csillogó", slug:"crystal-waves",        name:"Crystal Waves",         price:4990, compare:null, badge:"Bestseller",stock:8,  sub:"6 szin  .  Csillogó glitter", bg:"linear-gradient(135deg,#c5e8f0,#7ab8cc)", e:"wave", sizes:["XS","S","M","L","XL"], shape:"Szogletes", finish:"Glitter",   desc:"Hat csillogó szin hullammintas glitteres press-on kormokkel. Percek alatt szalonhatas. 24 db korom, tapasz, reszelo." },
  { id:"p3", group:"Francia", slug:"french-mix",           name:"French Mix",            price:4990, compare:null, badge:null,        stock:15, sub:"Francia stílus  ·  5 szín",   bg:"linear-gradient(135deg,#f0e8e7,#e8c4c0)", e:"flower", sizes:["XS","S","M","L","XL"], shape:"Ovalis",    finish:"Fenyes",    desc:"Francia press-on korom készletek tobb szinben es formaban. Irodaban es unnepen egyarant tokeletes." },
  { id:"p4", group:"Elegancia", slug:"golden-blush",         name:"Golden Blush Elegance", price:4990, compare:null, badge:null,        stock:10, sub:"Púder  ·  Arany ív",          bg:"linear-gradient(135deg,#f5e8d0,#e8d5b7)", e:"sparkle", sizes:["XS","S","M","L","XL"], shape:"Mandula",   finish:"Gyongyhar", desc:"Elegáns köröm púderrózsaszín alappal és arany csillámos ívvel. Gyöngyház felszín, mandula forma." },
  { id:"p5", group:"Csillogó", slug:"cosmic-emerald",       name:"Cosmic Emerald",        price:4990, compare:null, badge:null,        stock:6,  sub:"Zöld galaxis  ·  Hologr",     bg:"linear-gradient(135deg,#c5d4c0,#a8c0a8)", e:"green", sizes:["XS","S","M","L","XL"], shape:"Stilett",   finish:"Hologr",    desc:"Titokzatosan zöld, csillagfényes műköröm szett. Holografikus felület, stilett forma." },
  { id:"p6", group:"Szezonális", slug:"winter-whisper",       name:"Winter Whisper",        price:3990, compare:5490, badge:"Akcio",     stock:4,  sub:"Pasztell  ·  Hópehely",       bg:"linear-gradient(135deg,#fdf0f0,#f5d8d5)", e:"snow", sizes:["XS","S","M","L","XL"], shape:"Kerek",     finish:"Matt",      desc:"Letisztult elegancia és téli báj. Pasztell rózsaszín, hópehelyes minta, matt felület." },
  { id:"p7", group:"Kellékek", slug:"nail-glue-pro",        name:"Nail Glue Pro",         price:1490, compare:null, badge:null,        stock:30, sub:"Ragasztó  ·  5g",             bg:"linear-gradient(135deg,#e8e8f0,#d0d0e8)", e:"tool", sizes:[], shape:null, finish:null, desc:"Prémium köröm ragasztó press-on körmökhöz. Erős tapadás, könnyen eltávolítható. 1 csomag = 2-3 használat." },
  { id:"p8", group:"Kellékek", slug:"nail-prep-kit",        name:"Nail Prep Kit",         price:2490, compare:3990, badge:"Szett",     stock:20, sub:"Előkészítő csomag",         bg:"linear-gradient(135deg,#e0e8e8,#c0d4d4)", e:"gem", sizes:[], shape:null, finish:null, desc:"Teljes előkészítő csomag: reszelő, buffer, alkoholos törlőkendők, kutikula toló. Minden ami kell a tökéletes felhelyezéshez." },
];
const fmt = n => n.toLocaleString("hu-HU") + " Ft";

// Termek csoportok - dinamikusan bovitheto
const DEFAULT_GROUPS = ["Elegancia","Francia","Csillogó","Szezonális","Kellékek"];

function useW() {
  const [w,setW]=useState(typeof window!=="undefined"?window.innerWidth:1200);
  useEffect(()=>{const fn=()=>setW(window.innerWidth);window.addEventListener("resize",fn);return()=>window.removeEventListener("resize",fn);},[]);
  return w;
}

// --- ROZSA SZIRMOK -----------------------------------
// Gazdagabb, melyebb rozsaszirmok
const ROSE_COLORS = [
  "#e8728a","#c0445a","#f2a0b0","#d4566e","#f5bfc8",
  "#b83a52","#edb0bc","#cc4f66","#f8d0d8","#c84862",
];

let _roseBurst = null;

function RosePetals() {
  const [petals, setPetals] = useState([]);

  const burst = useCallback((n) => {
    const now = Date.now();
    const batch = Array.from({ length: n||28 }, (_, i) => ({
      id:    now + i + Math.random(),
      x:     Math.round(1 + Math.random() * 98),
      dur:   6 + Math.random() * 8,
      delay: i * 0.07 + Math.random() * 0.4,
      size:  Math.round(11 + Math.random() * 15),
      spin:  Math.round((Math.random()>.5?1:-1)*(120+Math.random()*360)),
      tilt:  Math.round(-45 + Math.random() * 90),
      drift: Math.round((Math.random()-.5)*200),
      sway:  Math.round(22 + Math.random() * 45),
      color: ROSE_COLORS[Math.floor(Math.random()*ROSE_COLORS.length)],
      type:  Math.floor(Math.random()*3),
    }));
    setPetals(p => [...p.slice(-70), ...batch]);
    setTimeout(() => setPetals(p => p.filter(x => !batch.find(b => b.id===x.id))), 17000);
  }, []);

  useEffect(() => { _roseBurst = burst; return () => { _roseBurst=null; }; }, [burst]);
  useEffect(() => { burst(32); }, []);

  return (
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:9980,overflow:"hidden"}}>
      {petals.map(p => {
        const kf = "rp"+Math.abs(Math.round(p.id));
        const sw2=Math.round(p.sway*.5), dr6=Math.round(p.drift*.6), sw9=Math.round(p.sway*.9);
        const sp2=Math.round(p.spin*.2), sp5=Math.round(p.spin*.5), sp8=Math.round(p.spin*.78);
        const css = "@keyframes "+kf+"{"+
          "0%{transform:translateY(0) translateX(0) rotate(0deg);opacity:0}"+
          "5%{opacity:1}"+
          "25%{transform:translateY(25vh) translateX("+sw2+"px) rotate("+sp2+"deg)}"+
          "50%{transform:translateY(52vh) translateX("+dr6+"px) rotate("+sp5+"deg)}"+
          "75%{transform:translateY(78vh) translateX("+sw9+"px) rotate("+sp8+"deg)}"+
          "94%{opacity:.65}"+
          "100%{transform:translateY(112vh) translateX("+p.drift+"px) rotate("+p.spin+"deg);opacity:0}"+
        "}";
        // 3 kulonbozo rozsa szirom SVG forma
        const petalSvg = p.type === 0
          // Kerek, vastag rozsa szirom
          ? <svg width={p.size} height={p.size*1.2} viewBox="0 0 24 28" style={{display:"block",filter:"drop-shadow(0 1px 4px rgba(192,68,90,.35))"}}>
              <path d="M12,2 C18,2 22,7 21,14 C20,21 14,26 12,26 C10,26 4,21 3,14 C2,7 6,2 12,2 Z" fill={p.color} opacity="0.92"/>
              <path d="M12,4 C17,4 20,8 19.5,14 C19,19 14,23 12,23" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="0.8"/>
              <path d="M12,6 Q14,12 12,22" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="0.6"/>
            </svg>
          : p.type === 1
          // Hegyes, karcsu rozsa szirom
          ? <svg width={p.size*0.8} height={p.size*1.4} viewBox="0 0 18 30" style={{display:"block",filter:"drop-shadow(0 1px 4px rgba(192,68,90,.3))"}}>
              <path d="M9,1 C15,4 18,10 16,18 C14,24 9,29 9,29 C9,29 4,24 2,18 C0,10 3,4 9,1 Z" fill={p.color} opacity="0.9"/>
              <path d="M9,3 C13,6 16,12 14.5,19" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="0.8"/>
            </svg>
          // Szeles, lekerekitett rozsa szirom
          : <svg width={p.size*1.2} height={p.size} viewBox="0 0 28 22" style={{display:"block",filter:"drop-shadow(0 1px 4px rgba(192,68,90,.3))"}}>
              <path d="M14,1 C22,1 27,6 27,12 C27,18 22,21 14,21 C6,21 1,18 1,12 C1,6 6,1 14,1 Z" fill={p.color} opacity="0.88"/>
              <path d="M14,3 C20,3 25,7 25,12" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="0.8"/>
              <path d="M14,5 Q16,10 14,19" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="0.6"/>
            </svg>;
        return (
          <div key={p.id} style={{position:"absolute",left:p.x+"%",top:"-6%",transform:"rotate("+p.tilt+"deg)",animation:kf+" "+p.dur+"s ease-in-out "+p.delay+"s forwards"}}>
            <style>{css}</style>
            {petalSvg}
          </div>
        );
      })}
    </div>
  );
}

// --- ROZSA PARALLAX ----------------------------------
// Hatterben arany korok + halvany rozsa korvonalak

// --- SPARK TRAIL - futo szikra nyomvonallal --------
function SparkTrail({ r, dur, delay, reverse, layerW, layerH }) {
  const [pos, setPos]     = React.useState({ x: layerW/2 + r, y: layerH/2 });
  const [sparks, setSparks] = React.useState([]);
  const frameRef  = React.useRef(null);
  const startRef  = React.useRef(null);

  React.useEffect(() => {
    const cx    = layerW / 2;
    const cy    = layerH / 2;
    const rPx   = r;
    const durMs = dur * 1000;
    const dir   = reverse ? -1 : 1;

    const tick = (now) => {
      if (!startRef.current) startRef.current = now - (delay * 1000 % durMs);
      const elapsed  = (now - startRef.current) % durMs;
      const progress = elapsed / durMs;
      const angle    = dir * progress * 2 * Math.PI - Math.PI / 2;
      const x = cx + rPx * Math.cos(angle);
      const y = cy + rPx * Math.sin(angle);

      setPos({ x, y });

      if (Math.random() < 0.06) {
        const id = now + Math.random();
        // Tangencialis irany - meroleges a sugarra
        const tx = -Math.sin(angle) * dir;
        const ty =  Math.cos(angle) * dir;
        // Ellentetes irany + kis random szoras
        const spread = (Math.random() - 0.5) * 1.5;
        const speed  = 1.5 + Math.random() * 2;
        const vx = -tx * speed + spread;
        const vy = -ty * speed + spread;
        setSparks(prev => [...prev.slice(-5), { id, x, y, vx, vy, life: 1 }]);
      }

      setSparks(prev => prev
        .map(s => ({ ...s, life: s.life - 0.05, x: s.x + s.vx, y: s.y + s.vy }))
        .filter(s => s.life > 0)
      );

      frameRef.current = requestAnimationFrame(tick);
    };

    frameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameRef.current);
  }, []);

  return (
    <>
      <circle cx={pos.x} cy={pos.y} r="0.35" fill="#f5d485"
        style={{filter:"drop-shadow(0 0 1px #b8924a) drop-shadow(0 0 3px rgba(184,146,74,.9))"}}/>
      {sparks.map(s => (
        <circle key={s.id} cx={s.x} cy={s.y}
          r={Math.max(0.05, 0.25 * s.life)} fill="#f5d485"
          opacity={s.life * 0.8}
          style={{filter:"drop-shadow(0 0 1px #f5d485)"}}/>
      ))}
    </>
  );
}

function RoseParallax() {
  const refs = useRef([]);

  const LAYERS = [
    { x:"68%",  y:"5%",  w:500, h:500, speed:0.05, delay:0  },
    { x:"-8%",  y:"25%", w:380, h:380, speed:0.03, delay:2  },
    { x:"40%",  y:"55%", w:560, h:560, speed:0.07, delay:1  },
    { x:"78%",  y:"60%", w:300, h:300, speed:0.04, delay:3  },
    { x:"15%",  y:"70%", w:420, h:420, speed:0.06, delay:1.5},
  ];

  useEffect(() => {
    const fn = () => {
      const sy = window.scrollY;
      refs.current.forEach((el, i) => {
        if (el) el.style.transform = "translateY("+(-sy * LAYERS[i].speed)+"px)";
      });
    };
    window.addEventListener("scroll", fn, {passive:true});
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const pulseAnim = LAYERS.map((_, i) =>
    "@keyframes rplx"+i+"{0%,100%{opacity:.85;transform:scale(1)}50%{opacity:1;transform:scale(1.04)}}"
  ).join("");

  // Szikra animaciok - korok menten futnak
  const sparkleAnim = [0,1,2,3].map(i =>
    "@keyframes spark"+i+"{0%{stroke-dashoffset:314}100%{stroke-dashoffset:0}}"
  ).join("") +
  "@keyframes sparkFade{0%,100%{opacity:0}10%,90%{opacity:1}}";

  return (
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:1,overflow:"hidden"}}>
      <style>{pulseAnim + sparkleAnim}</style>
      {LAYERS.map((l, i) => (
        <div
          key={i}
          ref={r => refs.current[i] = r}
          style={{position:"absolute",left:l.x,top:l.y,width:l.w,height:l.h,willChange:"transform"}}
        >
          <svg width={l.w} height={l.h} viewBox="0 0 100 100" style={{display:"block",position:"absolute",top:0,left:0,pointerEvents:"none",zIndex:2}}>
            {i < 3 && (
              <SparkTrail r={46} dur={18+i*4} delay={i*3}
                reverse={false} layerW={100} layerH={100}/>
            )}
            {i < 4 && (
              <SparkTrail r={34} dur={14+i*3} delay={i*2+1.5}
                reverse={true} layerW={100} layerH={100}/>
            )}
          </svg>
          <svg width={l.w} height={l.h} viewBox="0 0 100 100" style={{display:"block",animation:"rplx"+i+" "+(14+i*3)+"s ease-in-out "+l.delay+"s infinite"}}>
            {/* Kulso arany kor */}
            <circle cx="50" cy="50" r="46" fill="none" stroke={V.gold} strokeWidth="0.4" opacity={0.08+i*0.01}/>
            {/* Belso rozsa kor */}
            <circle cx="50" cy="50" r="34" fill="none" stroke={V.rose} strokeWidth="0.3" opacity={0.06+i*0.01}/>
            {/* Legbelso toltes */}
            <circle cx="50" cy="50" r="22" fill={V.rose} opacity={0.02}/>
            {/* Stilizalt rozsa korvonal */}
            <g opacity={0.07} stroke={V.rose} strokeWidth="0.4" fill="none">
              <path d="M50,30 Q60,35 62,45 Q65,55 58,62 Q50,68 42,62 Q35,55 38,45 Q40,35 50,30 Z"/>
              <path d="M50,34 Q57,38 59,46 Q62,54 56,60 Q50,65 44,60 Q38,54 41,46 Q43,38 50,34 Z"/>
            </g>


          </svg>
        </div>
      ))}
    </div>
  );
}

// --- HEADER ------------------------------------------
// --- HIRDETESSAV -------------------------------------
const BAR_MSGS = [
  " Ingyenes szállítás 10 000 Ft felett",
  "Kézzel készített, premium minoseg",
  "Új kollekció: Rose Garden 2025",
  "Egyedi rendelés lehetseges",
];
function AnnounceBar() {
  const [i, setI] = useState(0);
  const [vis, setVis] = useState(true);
  useEffect(() => {
    const t = setInterval(() => setI(x => (x+1) % BAR_MSGS.length), 3800);
    return () => clearInterval(t);
  }, []);
  if (!vis) return null;
  return (
    <div style={{ background:"linear-gradient(90deg,"+V.deep+",#2a4a2a,"+V.deep+")", color:"rgba(253,250,246,.88)", textAlign:"center", padding:"9px 48px 9px 16px", fontSize:11, letterSpacing:2, textTransform:"uppercase", fontWeight:500, position:"relative", zIndex:201, overflow:"hidden" }}>
      <span key={i} style={{ display:"inline-block", animation:"barSlide .4s ease" }}>{BAR_MSGS[i]}</span>
      <button onClick={() => setVis(false)} style={{ position:"absolute", right:14, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:"rgba(253,250,246,.5)", fontSize:18, cursor:"pointer", lineHeight:1, fontWeight:300 }}>x</button>
      <style>{"@keyframes barSlide{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}"}</style>
    </div>
  );
}

// --- POPUP -------------------------------------------
function Popup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    // 10 masodperc utan jelenik meg - hagyjuk az oldalt megnezni
    const t = setTimeout(() => setOpen(true), 10000);
    return () => clearTimeout(t);
  }, []);

  if (!open) return null;

  return (
    <div
      onClick={() => setOpen(false)}
      style={{ position:"fixed", inset:0, background:"rgba(42,26,30,.6)", backdropFilter:"blur(6px)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20, animation:"fadeIn .35s ease" }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background:V.ivory, maxWidth:480, width:"100%", position:"relative", animation:"popIn .4s ease", boxShadow:"0 32px 80px rgba(42,26,30,.25)", overflow:"hidden" }}
      >
        {/* Arany vonal tetejen */}
        <div style={{ height:3, background:"linear-gradient(90deg,"+V.gold+","+V.rose+","+V.gold+")", backgroundSize:"200% 100%", animation:"shimBar 3s linear infinite" }}/>

        {/* Rozsa dekor hatter */}
        <div style={{ position:"absolute", right:-20, top:-20, fontSize:120, opacity:.05, userSelect:"none", pointerEvents:"none" }}>{""}</div>

        <div style={{ padding:"clamp(28px,5vw,44px)" }}>
          <button onClick={() => setOpen(false)} style={{ position:"absolute", top:14, right:16, background:"none", border:"none", fontSize:22, color:V.muted, cursor:"pointer", lineHeight:1 }}>x</button>

          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
            <div style={{ width:22, height:1, background:V.gold }}/>
            <span style={{ fontSize:9, letterSpacing:4, textTransform:"uppercase", color:V.gold, fontWeight:600 }}>Exkluziv ajanlat</span>
          </div>

          {done ? (
            <div style={{ textAlign:"center", padding:"12px 0" }}>
              <div style={{ fontSize:36, marginBottom:12 }}>{""}</div>
              <h3 style={{ fontFamily:"Georgia,serif", fontSize:22, fontWeight:400, color:V.dark, marginBottom:8 }}>Koszonjuk!</h3>
              <p style={{ fontSize:13, color:V.muted, lineHeight:1.7 }}>Elkuld 10% kupont az email-edre. Ellenorizd a postafiokodat!</p>
              <div style={{ marginTop:16, fontSize:13, fontWeight:700, color:V.rose, letterSpacing:2 }}>WELCOME10</div>
            </div>
          ) : (
            <>
              <h3 style={{ fontFamily:"Georgia,serif", fontSize:"clamp(20px,4vw,28px)", fontWeight:400, color:V.dark, marginBottom:10, lineHeight:1.15 }}>
                {"Kapj 10% kedvezményt az első rendelésedre!"}
              </h3>
              <p style={{ fontSize:13, color:V.muted, lineHeight:1.75, marginBottom:22 }}>
                {"Iratkozz fel hírlevelünkre és azonnal küldjük a kupont. Csak az első 100 feliratkozónak!"}
              </p>
              <div style={{ display:"flex", gap:0, marginBottom:14 }}>
                <input
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key==="Enter" && email.includes("@") && setDone(true)}
                  placeholder="email@cimed.hu"
                  style={{ flex:1, background:"white", border:"1px solid "+V.border, borderRight:"none", padding:"12px 14px", fontSize:14, color:V.dark, outline:"none" }}
                />
                <button
                  onClick={() => email.includes("@") && setDone(true)}
                  style={{ background:V.rose, color:V.cream, border:"none", padding:"12px 20px", fontSize:10, letterSpacing:2.5, textTransform:"uppercase", fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}
                >
                  Kuldj kupont
                </button>
              </div>
              <button onClick={() => setOpen(false)} style={{ background:"none", border:"none", fontSize:12, color:V.muted, cursor:"pointer", textDecoration:"underline" }}>
                {"Nem kérek kedvezményt"}
              </button>
            </>
          )}
        </div>
      </div>
      <style>{"@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes popIn{from{opacity:0;transform:scale(.94) translateY(16px)}to{opacity:1;transform:none}}@keyframes shimBar{0%{background-position:200% center}100%{background-position:-200% center}}"}</style>
    </div>
  );
}

function Header({ tab, setTab }) {
  const { count } = useCart();
  const { isAdmin } = useAuth();
  const w = useW();
  const mob = w < 520;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", fn, {passive:true});
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const NAV = [
    ["home",       "Főoldal"],
    ["termékek",   "Kollekció"],
    ["vélemények", "Vélemények"],
    ["rolunk",     "Rózsakertről"],
    ["egyedi",     "Egyedi"],
    ["fiókom",     "Fiókom"],
    ["hírlevel",   "Hírlevel"],
  ];
  const ADMIN_NAV = isAdmin ? [["admin-termékek","Admin"]] : [];

  return (
    <header style={{
      position:"sticky", top:0, zIndex:200,
      background: scrolled ? "rgba(253,250,246,.99)" : "rgba(253,250,246,.95)",
      backdropFilter:"blur(18px)",
      borderBottom:"1px solid "+V.border,
      boxShadow: scrolled ? "0 4px 20px rgba(192,68,90,.08)" : "none",
      transition:"box-shadow .3s",
    }}>
      {/* Felso sor: logo + kosar */}
      <div style={{
        maxWidth:1280, margin:"0 auto",
        padding:"0 "+(mob?12:32)+"px",
        height:52,
        display:"flex", alignItems:"center", justifyContent:"space-between", gap:12,
      }}>
        <button onClick={()=>setTab("home")} style={{background:"none",border:"none",cursor:"pointer",textAlign:"left",flexShrink:0}}>
          <div style={{lineHeight:1}}>
            <span style={{fontFamily:"Georgia,serif",fontSize:mob?18:24,fontWeight:400,color:V.rose,letterSpacing:1}}>{"Evi's "}</span><span style={{fontFamily:"'Cormorant Garamond', 'Playfair Display', Georgia, serif",fontSize:mob?18:24,fontWeight:400,fontStyle:"italic",color:V.dark,letterSpacing:1.5}}>{"Nail Art"}</span>
          </div>
          {!mob && <div style={{fontSize:7,letterSpacing:3,textTransform:"uppercase",color:V.gold,marginTop:3,opacity:.7}}>Rose Garden Collection</div>}
        </button>
        <button onClick={()=>setTab("kosár")} style={{
          background:V.rose, color:V.cream, border:"none",
          padding:"8px 16px", fontSize:10, letterSpacing:2,
          textTransform:"uppercase", fontWeight:700, cursor:"pointer",
          display:"flex", alignItems:"center", gap:7, flexShrink:0,
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          {!mob && "Kosár"}
          {count > 0 && (
            <span style={{background:"rgba(255,255,255,.32)",borderRadius:"50%",width:17,height:17,fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{count}</span>
          )}
        </button>
      </div>

      {/* Nav sav: mindig latszik, vizszintesen scrollozhato */}
      <div style={{borderTop:"1px solid rgba(192,68,90,.08)",background:"rgba(240,245,238,.6)",overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
        <nav style={{
          display:"flex", alignItems:"stretch",
          padding:"0 "+(mob?4:32)+"px",
          minWidth:"max-content",
        }}>
          {[...NAV, ...ADMIN_NAV].map(([k,l]) => {
            const active = tab===k || (k==="termékek" && tab.startsWith("termek-"));
            return (
              <button key={k} onClick={()=>setTab(k)} style={{
                background:"none", border:"none", cursor:"pointer",
                padding: mob ? "9px 11px" : "10px 18px",
                fontSize: mob ? 9 : 10,
                letterSpacing: 1.8,
                fontWeight: active ? 700 : 500,
                color: active ? V.rose : V.muted,
                borderBottom: active ? "2px solid "+V.rose : "2px solid transparent",
                transition:"color .18s, border-color .18s",
                whiteSpace:"nowrap",
                flexShrink:0,
              }}>
                {l}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

// --- HERO --------------------------------------------
function Hero({ setTab }) {
  const w = useW(); const mob = w < 700;
  return (
    <section style={{position:"relative",minHeight:"92vh",display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",overflow:"hidden"}}>
      {/* Bal oldal - szoveg */}
      <div style={{background:V.ivory,display:"flex",flexDirection:"column",justifyContent:"center",padding:mob?"56px 20px":"80px 72px",position:"relative",overflow:"hidden",zIndex:2}}>

        {/* Art deco arany disz - bal szel */}
        {!mob && (
          <div style={{position:"absolute",left:14,top:0,bottom:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:0,pointerEvents:"none"}}>
            {/* Felso vonal */}
            <div style={{width:1,flex:1,background:"linear-gradient(to bottom,transparent,rgba(184,146,74,.35))"}}/>
            {/* Rombusz 1 */}
            <div style={{width:6,height:6,background:"rgba(184,146,74,.55)",transform:"rotate(45deg)",flexShrink:0,margin:"6px 0"}}/>
            {/* Kozep vonal */}
            <div style={{width:1,height:40,background:"rgba(184,146,74,.25)",flexShrink:0}}/>
            {/* Rozsa kor */}
            <div style={{width:20,height:20,borderRadius:"50%",border:"1px solid rgba(184,146,74,.4)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,margin:"4px 0"}}>
              <div style={{width:5,height:5,borderRadius:"50%",background:"rgba(184,146,74,.6)"}}/>
            </div>
            {/* Kozep vonal */}
            <div style={{width:1,height:40,background:"rgba(184,146,74,.25)",flexShrink:0}}/>
            {/* Rombusz 2 */}
            <div style={{width:4,height:4,background:"rgba(184,146,74,.4)",transform:"rotate(45deg)",flexShrink:0,margin:"6px 0"}}/>
            {/* Kozep vonal */}
            <div style={{width:1,height:60,background:"rgba(184,146,74,.2)",flexShrink:0}}/>
            {/* Nagy rombusz kozep */}
            <div style={{width:8,height:8,background:"rgba(184,146,74,.5)",transform:"rotate(45deg)",flexShrink:0,margin:"6px 0"}}/>
            {/* Kozep vonal */}
            <div style={{width:1,height:60,background:"rgba(184,146,74,.2)",flexShrink:0}}/>
            {/* Rombusz 3 */}
            <div style={{width:4,height:4,background:"rgba(184,146,74,.4)",transform:"rotate(45deg)",flexShrink:0,margin:"6px 0"}}/>
            {/* Kozep vonal */}
            <div style={{width:1,height:40,background:"rgba(184,146,74,.25)",flexShrink:0}}/>
            {/* Also rozsa kor */}
            <div style={{width:20,height:20,borderRadius:"50%",border:"1px solid rgba(184,146,74,.4)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,margin:"4px 0"}}>
              <div style={{width:5,height:5,borderRadius:"50%",background:"rgba(184,146,74,.6)"}}/>
            </div>
            {/* Kozep vonal */}
            <div style={{width:1,height:40,background:"rgba(184,146,74,.25)",flexShrink:0}}/>
            {/* Rombusz 4 */}
            <div style={{width:6,height:6,background:"rgba(184,146,74,.55)",transform:"rotate(45deg)",flexShrink:0,margin:"6px 0"}}/>
            {/* Also vonal */}
            <div style={{width:1,flex:1,background:"linear-gradient(to bottom,rgba(184,146,74,.35),transparent)"}}/>
          </div>
        )}

        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:18}}>
          <div style={{width:28,height:1,background:V.gold}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Rose Garden 2025</span>
        </div>
        <h1 style={{fontFamily:"Georgia,serif",fontSize:mob?"clamp(32px,10vw,48px)":"clamp(42px,4.5vw,64px)",fontWeight:400,lineHeight:1.07,color:V.dark,letterSpacing:-.5,marginBottom:20}}>
          Minden k{"ö"}r{"ö"}m<br/>
          egy <em style={{color:V.rose,fontStyle:"italic"}}>r{"ó"}zsa</em><br/>
          t{"ö"}rt{"é"}nete
        </h1>
        <p style={{fontSize:14,color:V.muted,maxWidth:360,lineHeight:1.9,marginBottom:36}}>
          A r{"ó"}zsakert eleganci{"á"}j{"á"}t hozzuk el az ujjaidra. K{"é"}zzel k{"é"}sz{"í"}tett press-on k{"ö"}rm{"ö"}k, friss r{"ó"}zsa szirma ihlette sz{"í"}nekben {"é"}s form{"á"}kban.
        </p>
        <div style={{display:"flex",gap:14,flexWrap:"wrap",alignItems:"center"}}>
          <button onClick={()=>setTab("termékek")} style={{background:V.rose,color:V.cream,border:"none",padding:"14px 32px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>
            Kollekci{"ó"}
          </button>
          <button onClick={()=>setTab("egyedi")} style={{background:"none",border:"1px solid "+V.border,color:V.rose,padding:"14px 28px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:600,cursor:"pointer"}}>
            Egyedi rendel{"é"}s
          </button>
        </div>
        <div style={{display:"flex",gap:32,marginTop:48,paddingTop:28,borderTop:"1px solid rgba(192,68,90,.1)"}}>
          {[["500+","Boldog vásárló",V.rose],["100%","Kézzel készített","#4a7c59"],["","Rózsa minőség",V.gold]].map(([n,l,col])=>(
            <div key={l}>
              <div style={{fontFamily:"Georgia,serif",fontSize:24,fontWeight:400,color:col,lineHeight:1}}>{n}</div>
              <div style={{fontSize:9,color:V.muted,letterSpacing:2,textTransform:"uppercase",marginTop:5}}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Jobb oldal - kinyilo rozsa animacio */}
      {!mob && (
        <div style={{background:"linear-gradient(135deg,#2a1a1e 0%,#140810 55%,#0a0408 100%)",display:"flex",alignItems:"center",justifyContent:"center",position:"relative",overflow:"hidden"}}>
          <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse at 58% 48%,rgba(192,68,90,.13) 0%,transparent 65%)",pointerEvents:"none"}}/>

          {/* Kinyilo rozsa - SVG SMIL animacioval */}
          <svg width="340" height="340" viewBox="0 0 200 200" style={{position:"relative",zIndex:2,filter:"drop-shadow(0 0 40px rgba(192,68,90,.35))"}}>
            <defs>
              <radialGradient id="rg1" cx="38%" cy="32%" r="62%">
                <stop offset="0%" stopColor="#f5bfc8"/>
                <stop offset="35%" stopColor="#c0445a"/>
                <stop offset="100%" stopColor="#6a1428"/>
              </radialGradient>
              <radialGradient id="rg2" cx="38%" cy="32%" r="62%">
                <stop offset="0%" stopColor="#f2a0b0"/>
                <stop offset="100%" stopColor="#8a1e38"/>
              </radialGradient>
              <radialGradient id="rg3">
                <stop offset="0%" stopColor="#fce8ef"/>
                <stop offset="100%" stopColor="#c0445a"/>
              </radialGradient>
              <radialGradient id="rgold" cx="40%" cy="35%" r="60%">
                <stop offset="0%" stopColor="#f5d485"/>
                <stop offset="100%" stopColor="#7a5018"/>
              </radialGradient>
            </defs>

            {/* Zold cseszelebelek - csak a kulso szirmok tovenel */}
            {[20,65,110,155,200,245,290,335].map((angle, i) => (
              <g key={"s"+i} transform={"translate(100,100) rotate("+angle+")"}>
                <ellipse cx="0" cy="-44" rx="5" ry="0" fill="#2d5a2d" opacity="0">
                  <animate attributeName="opacity" from="0" to="0.28" begin="0.1s" dur="2.2s" fill="freeze"/>
                  <animate attributeName="ry" from="0" to="14" begin="0.1s" dur="2.2s" calcMode="spline" keySplines="0.25,0.1,0.25,1" fill="freeze"/>
                </ellipse>
              </g>
            ))}

            {/* Kulso szirmok - 8 db, 0.2s-tol */}
            {[0,45,90,135,180,225,270,315].map((angle, i) => (
              <g key={"o"+i} transform={"translate(100,100) rotate("+angle+")"}>
                <ellipse cx="0" cy="-46" rx="18" ry="0" fill="url(#rg1)" opacity="0"
                  style={{
                    animation: "sway"+(i%2) + " " + (3.2+i*0.3) + "s ease-in-out 2.3s infinite",
                    transformOrigin: "0px 0px",
                  }}>
                  <animate attributeName="opacity" from="0" to="0.92" begin="0.2s" dur="2.0s" fill="freeze"/>
                  <animate attributeName="ry" from="0" to="28" begin="0.2s" dur="2.0s" calcMode="spline" keySplines="0.25,0.1,0.25,1" fill="freeze"/>
                </ellipse>
              </g>
            ))}

            {/* Kozepso szirmok - 8 db, 2.5s-tol */}
            {[0,45,90,135,180,225,270,315].map((angle, i) => (
              <g key={"m"+i} transform={"translate(100,100) rotate("+angle+")"}>
                <ellipse cx="0" cy="-30" rx="13" ry="0" fill="url(#rg2)" opacity="0"
                  style={{
                    animation: "sway"+(i%2) + " " + (2.8+i*0.25) + "s ease-in-out 4.4s infinite",
                    transformOrigin: "0px 0px",
                  }}>
                  <animate attributeName="opacity" from="0" to="0.9" begin="2.5s" dur="1.8s" fill="freeze"/>
                  <animate attributeName="ry" from="0" to="20" begin="2.5s" dur="1.8s" calcMode="spline" keySplines="0.25,0.1,0.25,1" fill="freeze"/>
                </ellipse>
              </g>
            ))}

            {/* Belso szirmok - 5 db, 4.8s-tol */}
            {[0,72,144,216,288].map((angle, i) => (
              <g key={"i"+i} transform={"translate(100,100) rotate("+angle+")"}>
                <ellipse cx="0" cy="-16" rx="10" ry="0" fill="url(#rg3)" opacity="0"
                  style={{
                    animation: "sway"+(i%2) + " " + (2.4+i*0.2) + "s ease-in-out 6.4s infinite",
                    transformOrigin: "0px 0px",
                  }}>
                  <animate attributeName="opacity" from="0" to="0.88" begin="4.8s" dur="1.5s" fill="freeze"/>
                  <animate attributeName="ry" from="0" to="15" begin="4.8s" dur="1.5s" calcMode="spline" keySplines="0.25,0.1,0.25,1" fill="freeze"/>
                </ellipse>
              </g>
            ))}

            {/* Mag - 6.5s */}
            <g transform="translate(100,100)">
              <circle cx="0" cy="0" r="0" fill="url(#rgold)" opacity="0">
                <animate attributeName="opacity" from="0" to="1" begin="6.5s" dur="1.0s" fill="freeze"/>
                <animate attributeName="r" from="0" to="11" begin="6.5s" dur="1.0s" calcMode="spline" keySplines="0.25,0.1,0.25,1" fill="freeze"/>
              </circle>
              <circle cx="-2.5" cy="-2.5" r="0" fill="rgba(255,248,210,.65)" opacity="0">
                <animate attributeName="opacity" from="0" to="1" begin="7.0s" dur="0.8s" fill="freeze"/>
                <animate attributeName="r" from="0" to="4.5" begin="7.0s" dur="0.8s" fill="freeze"/>
              </circle>
            </g>
          </svg>

          {/* Hatter rozsa - szello effekttel */}
          <svg width="500" height="500" viewBox="0 0 200 200" style={{position:"absolute",opacity:.08}}>
            <g transform="translate(100,100)">
              {[0,40,80,120,160,200,240,280,320].map((a,i)=>(
                <g key={i} transform={"rotate("+a+")"}>
                  <ellipse cx="0" cy="-54" rx="19" ry="32" fill={V.rose} opacity="0.9"
                    style={{
                      animation:"sway"+(i%2)+" "+(4+i*0.4)+"s ease-in-out "+(i*0.3)+"s infinite",
                      transformOrigin:"0px 0px",
                    }}/>
                </g>
              ))}
            </g>
          </svg>

          {/* Animalt arany szikrak */}
          {[[12,18,1.8,0],[85,12,2.1,0.4],[90,72,1.6,0.8],[8,78,2.3,0.2],[50,90,1.9,1.1],[94,44,2.4,0.6],[6,50,1.7,0.9],[72,8,2.0,0.3]].map(([x,y,dur,delay],i)=>(
            <div key={i} style={{
              position:"absolute", left:x+"%", top:y+"%",
              width:3+i%2, height:3+i%2,
              borderRadius:"50%",
              background:V.gold,
              boxShadow:"0 0 "+(4+i%3*3)+"px "+(2+i%2)+"px rgba(184,146,74,.7)",
              animation:"sparkle"+i+" "+dur+"s ease-in-out "+delay+"s infinite",
            }}/>
          ))}
          <style>{[0,1,2,3,4,5,6,7].map(i => {
            const s = 0.3 + (i%3)*0.2;
            const p1 = Math.round(30+i*8);
            const p2 = Math.round(60+i*5);
            return "@keyframes sparkle"+i+"{0%,100%{opacity:0.2;transform:scale("+s+")}"+p1+"%{opacity:1;transform:scale(1.8)}"+p2+"%{opacity:0.6;transform:scale(0.8)}}";
          }).join("")}</style>

          <div style={{position:"absolute",inset:20,border:"1px solid rgba(184,146,74,.14)",pointerEvents:"none"}}/>
          <div style={{position:"absolute",inset:26,border:"1px solid rgba(184,146,74,.07)",pointerEvents:"none"}}/>
          <div style={{position:"absolute",bottom:28,left:0,right:0,textAlign:"center"}}>
            <span style={{fontSize:8,letterSpacing:4,textTransform:"uppercase",color:"rgba(184,146,74,.35)",fontWeight:600}}>Rose Garden Collection</span>
          </div>
        </div>
      )}
    </section>
  );
}

// --- TERMEKEK ----------------------------------------
// --- SPOTLIGHT SHOWCASE -----------------------------
// --- ROSE SPOTLIGHT SHOWCASE ------------------------
// Luxus kiemeles: sotet szinpad, arany feny, rozsa szirmok
// Hover-re a termekbol rozsa szirmok hullanak ki

// --- LIQUID GOLD SHOWCASE ---------------------------
// Folyekony arany keret fut vegig a termekeken
// Hover-re elolvad es arany cseppek hullanak le

// --- SZETNYILO ROZSA SHOWCASE -----------------------
// A termek el van takarva egy zart rozsaval
// Hover-re a rózsa szirmait szel fujja szet
// es mogotte elobukkan a termek

const FEATURED = [
  { id:"f1", name:"Golden Blush Elegance", sub:"Púder  ·  Arany ív  .  Gyongyhar", price:4990,
    badge:"Legjobb eladas",
    closedBg:"linear-gradient(160deg,#1a1008,#2e1e0a,#1a1008)",
    revealBg:"linear-gradient(160deg,#f5e8d0,#e8d5b7,#c9a55a)",
    accentColor:"rgba(201,165,90,1)", accentAlpha:"rgba(201,165,90,0.18)", accentDim:"rgba(201,165,90,0.04)",
    petalColors:["#f5d485","#c9a55a","#e8d5b7","#f5e8d0","#d4a857","#f0c870"],
    e:"sparkle",
    tags:["Mandula forma","Gyongyhar felulet","Újrahasznosithato"],
    desc:"Az elso randevutol az eskuvoig. Puderrozsaszin alap, arany csillamos iv." },
  { id:"f2", name:"French Mix", sub:"Francia stílus  ·  5 szín  .  Fenyes", price:4990,
    badge:"Klasszikus",
    closedBg:"linear-gradient(160deg,#180810,#2a1020,#180810)",
    revealBg:"linear-gradient(160deg,#f0e8e7,#e8c4c0,#c9857c)",
    accentColor:"rgba(192,68,90,1)", accentAlpha:"rgba(192,68,90,0.18)", accentDim:"rgba(192,68,90,0.04)",
    petalColors:["#f2a0b0","#e8728a","#c0445a","#fce8ef","#d4566e","#f5bfc8"],
    e:"flower",
    tags:["Ovalis forma","Fenyes felulet","5 szinben"],
    desc:"Az idotlen klasszikus. Irodaban es unnepen egyarant tokeletes." },
];

// Hullo szirmok a lepel felemelesekor
function FallingSparks({ active, colors }) {
  const [sparks, setSparks] = useState([]);
  const fired = useRef(false);
  useEffect(() => {
    if (active && !fired.current) {
      fired.current = true;
      const batch = Array.from({ length: 22 }, (_, i) => ({
        id: Date.now() + i,
        x:  10 + Math.random() * 80,
        delay: 0.25 + Math.random() * 0.5,
        dur:   1.0 + Math.random() * 0.7,
        size:  5 + Math.round(Math.random() * 9),
        drift: Math.round((Math.random() - 0.5) * 160),
        rot:   Math.round((Math.random() - 0.5) * 640),
        color: colors[Math.floor(Math.random() * colors.length)],
        shape: Math.floor(Math.random() * 3),
      }));
      setSparks(batch);
      setTimeout(() => { setSparks([]); fired.current = false; }, 2400);
    }
    if (!active) { fired.current = false; setSparks([]); }
  }, [active]);

  return (
    <div style={{ position:"absolute", inset:0, pointerEvents:"none", zIndex:20, overflow:"visible" }}>
      {sparks.map(s => {
        const kf = "fsp" + s.id;
        const css = "@keyframes "+kf+"{0%{opacity:0;transform:translate(0,0) rotate(0deg) scale(.3)}12%{opacity:1;transform:translate(0,-12px) scale(1)}100%{opacity:0;transform:translate("+s.drift+"px,160px) rotate("+s.rot+"deg) scale(.15)}}";
        const el = s.shape === 0
          ? <svg width={s.size} height={s.size*1.3} viewBox="0 0 20 26"><path d="M10,1 C16,2 19,8 18,14 C17,20 10,25 10,25 C10,25 3,20 2,14 C1,8 4,2 10,1 Z" fill={s.color} opacity="0.92"/><path d="M10,4 C14,5 17,10 16,15" fill="none" stroke="rgba(255,255,255,0.28)" strokeWidth="1"/></svg>
          : s.shape === 1
          ? <div style={{ width:s.size, height:s.size, borderRadius:"50%", background:s.color, boxShadow:"0 0 "+(s.size*1.5)+"px "+s.color }}/>
          : <svg width={s.size} height={s.size} viewBox="0 0 12 12"><polygon points="6,0 7.5,4.5 12,4.5 8.5,7 9.5,12 6,9 2.5,12 3.5,7 0,4.5 4.5,4.5" fill={s.color}/></svg>;
        return (
          <div key={s.id} style={{ position:"absolute", left:s.x+"%", bottom:"8%", animation:kf+" "+s.dur+"s ease-out "+s.delay+"s forwards" }}>
            <style>{css}</style>
            {el}
          </div>
        );
      })}
    </div>
  );
}

function FeaturedShowcase({ setTab }) {
  const [hov, setHov]   = useState(null);
  const w = useW(); const mob = w < 700;
  const cardW = mob ? Math.min(w - 48, 252) : 264;
  const cardH = Math.round(cardW * 1.35);

  // CSS animaciok
  const globalCss =
    // Lepel felgordules: clip-path inset(0 0 0% 0) -> inset(0 0 100% 0)
    "@keyframes curtainUp{0%{clip-path:inset(0 0 0% 0 round 0)}100%{clip-path:inset(0 0 102% 0 round 0)}}" +
    "@keyframes curtainDown{0%{clip-path:inset(0 0 102% 0 round 0)}100%{clip-path:inset(0 0 0% 0 round 0)}}" +
    // Termek elotuno
    "@keyframes prodReveal{0%{opacity:0;transform:translateY(10px) scale(.97)}100%{opacity:1;transform:none}}" +
    // Arany feny alulrol
    "@keyframes goldRise{0%{opacity:0;transform:scaleX(.6)}100%{opacity:1;transform:scaleX(1)}}" +
    // Szegely pulse
    "@keyframes borderPulse{0%,100%{opacity:.6}50%{opacity:1}}" +
    // Cimke hint pulzalas
    "@keyframes hintGlow{0%,100%{opacity:.35}50%{opacity:.65}}";

  return (
    <section style={{ background:"linear-gradient(180deg,"+V.dark+" 0%,#070309 52%,"+V.dark+" 100%)", padding:"clamp(64px,8vw,110px) 0", overflow:"hidden", position:"relative" }}>
      <style>{globalCss}</style>

      {/* Hatter atmoszfera golyok */}
      <div style={{ position:"absolute", left:"22%", top:"35%", width:420, height:380, borderRadius:"50%", background:"radial-gradient(circle,rgba(201,165,90,.05) 0%,transparent 72%)", pointerEvents:"none", filter:"blur(3px)" }}/>
      <div style={{ position:"absolute", left:"58%", top:"38%", width:360, height:340, borderRadius:"50%", background:"radial-gradient(circle,rgba(192,68,90,.04) 0%,transparent 72%)", pointerEvents:"none", filter:"blur(3px)" }}/>

      {/* Cim */}
      <div style={{ textAlign:"center", marginBottom:mob?44:68, position:"relative", zIndex:3 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:18, marginBottom:16 }}>
          <div style={{ flex:1, maxWidth:88, height:1, background:"linear-gradient(90deg,transparent,rgba(201,165,90,.55))" }}/>
          <svg width="14" height="17" viewBox="0 0 14 18" style={{ flexShrink:0 }}>
            <path d="M7,0 C11,0 14,4 13,9 C12,14 7,18 7,18 C7,18 2,14 1,9 C0,4 3,0 7,0 Z" fill={V.gold} opacity="0.85"/>
            <path d="M7,3 C10,4 12,7 11.5,10" fill="none" stroke="rgba(255,248,220,.3)" strokeWidth=".9"/>
          </svg>
          <span style={{ fontSize:9, letterSpacing:5, textTransform:"uppercase", color:V.gold, fontWeight:600, whiteSpace:"nowrap" }}>Kiemelt termekek</span>
          <svg width="14" height="17" viewBox="0 0 14 18" style={{ flexShrink:0 }}>
            <path d="M7,0 C11,0 14,4 13,9 C12,14 7,18 7,18 C7,18 2,14 1,9 C0,4 3,0 7,0 Z" fill={V.gold} opacity="0.85"/>
          </svg>
          <div style={{ flex:1, maxWidth:88, height:1, background:"linear-gradient(90deg,rgba(201,165,90,.55),transparent)" }}/>
        </div>
        <h2 style={{ fontFamily:"Georgia,serif", fontSize:"clamp(26px,4vw,48px)", fontWeight:400, color:V.cream, lineHeight:1.07, letterSpacing:-.5 }}>
          {"Kiemelt "}<em style={{ color:V.rose, fontStyle:"italic" }}>{"kollekci\u00f3"}</em>
        </h2>
        {!mob && <p style={{ fontSize:10, color:"rgba(253,250,246,.18)", marginTop:12, letterSpacing:2 }}>Vidd az egeret a term{"é"}kekre</p>}
      </div>

      {/* Termek par */}
      <div style={{ display:"flex", justifyContent:"center", alignItems:"flex-start", gap:mob?36:72, flexWrap:mob?"wrap":"nowrap", padding:mob?"0 16px":0, position:"relative", zIndex:3 }}>
        {FEATURED.map((prod, idx) => {
          const isHov = hov === idx;
          return (
            <div key={prod.id} style={{ display:"flex", flexDirection:"column", alignItems:"center" }}
              onMouseEnter={() => setHov(idx)}
              onMouseLeave={() => setHov(null)}
            >
              {/* Badge */}
              <div style={{ marginBottom:20 }}>
                <span style={{ fontSize:8, letterSpacing:3, textTransform:"uppercase", color:isHov?V.dark:V.gold, background:isHov?V.gold:"transparent", border:"1px solid rgba(201,165,90,.4)", padding:"5px 18px", fontWeight:700, transition:"all .45s", cursor:"pointer" }}>
                  {prod.badge}
                </span>
              </div>

              {/* FO KARTYA */}
              <div style={{ position:"relative", width:cardW, height:cardH, cursor:"pointer" }}>

                {/* Arany halos feny */}
                <div style={{ position:"absolute", inset:-28, background:"radial-gradient(ellipse at 50% 65%, "+(isHov ? prod.accentAlpha : "rgba(201,165,90,0.04)")+" 0%, transparent 68%)", transition:"all .7s ease", pointerEvents:"none", zIndex:0 }}/>

                {/* TERMEK KEP - a lepel mogott */}
                <div style={{ position:"absolute", inset:0, background:isHov?prod.revealBg:prod.closedBg, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", zIndex:1, transition:"background .5s .25s" }}>
                  <span style={{ fontSize:mob?66:86, opacity:isHov?1:0, transform:isHov?"scale(1) translateY(0)":"scale(.8) translateY(12px)", transition:"opacity .45s .45s, transform .45s .45s" }}>
                    {prod.e}
                  </span>
                  {/* Feny felulet */}
                  <div style={{ position:"absolute", top:0, left:0, right:0, height:"38%", background:"linear-gradient(180deg,rgba(255,255,255,.09),transparent)", pointerEvents:"none" }}/>
                  {/* Arany feny alulrol reveal-kor */}
                  {isHov && (
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, height:"40%", background:"linear-gradient(0deg,"+prod.accentAlpha+" 0%,transparent 100%)", animation:"goldRise .6s ease .3s both" }}/>
                  )}
                  {/* Arany sarokdiszek reveal utan */}
                  {isHov && [["top","left"],["top","right"],["bottom","left"],["bottom","right"]].map(([v,h],i) => (
                    <div key={v+h} style={{ position:"absolute", [v]:10, [h]:10, width:18, height:18, borderTop:v==="top"?"1.5px solid rgba(201,165,90,.65)":"none", borderBottom:v==="bottom"?"1.5px solid rgba(201,165,90,.65)":"none", borderLeft:h==="left"?"1.5px solid rgba(201,165,90,.65)":"none", borderRight:h==="right"?"1.5px solid rgba(201,165,90,.65)":"none", animation:"prodReveal .35s ease "+(0.5+i*.06)+"s both" }}/>
                  ))}
                </div>

                {/* BARSONY LEPEL - clip-path animacioval gordul fel */}
                <div style={{ position:"absolute", inset:0, zIndex:8, pointerEvents:"none", clipPath: isHov ? "inset(0 0 102% 0 round 0)" : "inset(0 0 0% 0 round 0)", animation: isHov ? "curtainUp .78s cubic-bezier(.76,0,.24,1) forwards" : "curtainDown .55s cubic-bezier(.76,0,.24,1) forwards" }}>
                  {/* Barsony anyag */}
                  <div style={{ position:"absolute", inset:0, background:"linear-gradient(160deg,"+prod.closedBg.split(",")[1].trim()+" 0%,"+prod.closedBg.split(",")[2].trim()+" 50%,"+prod.closedBg.split(",")[1].trim()+" 100%)" }}>
                    {/* Barsony fenyszalak */}
                    {Array.from({length:7},(_,i)=>(
                      <div key={i} style={{ position:"absolute", top:0, bottom:0, left:(i*15)+"%", width:"9%", background:"linear-gradient(180deg,rgba(255,255,255,0),rgba(255,255,255,"+(0.025+i%3*0.015)+") 50%,rgba(255,255,255,0))", transform:"skewX(-6deg)" }}/>
                    ))}
                    {/* Also arany szegely */}
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, height:3, background:"linear-gradient(90deg,transparent,rgba(201,165,90,.7),rgba(245,212,133,.95),rgba(201,165,90,.7),transparent)" }}/>
                    <div style={{ position:"absolute", bottom:3, left:"8%", right:"8%", height:1, background:"rgba(201,165,90,.22)" }}/>
                    {/* Logo a lepelen */}
                    <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:10 }}>
                      <svg width="36" height="36" viewBox="0 0 36 36" style={{ opacity:.3 }}>
                        <path d="M18,3 C26,3 32,8 31,18 C30,27 18,33 18,33 C18,33 6,27 5,18 C4,8 10,3 18,3 Z" fill="none" stroke="rgba(201,165,90,.9)" strokeWidth="0.9"/>
                        <path d="M18,8 C24,8 29,12 28,18 C27,23 18,28 18,28 C18,28 9,23 8,18 C7,12 12,8 18,8 Z" fill="none" stroke="rgba(201,165,90,.55)" strokeWidth="0.7"/>
                        <path d="M18,13 C22,13 25,15.5 24,18 C23,20.5 18,23 18,23 C18,23 13,20.5 12,18 C11,15.5 14,13 18,13 Z" fill="rgba(201,165,90,.12)"/>
                      </svg>
                      <div style={{ fontSize:8, letterSpacing:5, textTransform:"uppercase", color:"rgba(201,165,90,.35)", fontWeight:600 }}>{"Evi's"}</div>
                      {/* Hint szoveg */}
                      <div style={{ marginTop:4, fontSize:8, letterSpacing:2, textTransform:"uppercase", color:"rgba(253,250,246,.22)", animation:"hintGlow 2.2s ease-in-out infinite" }}>Nyisd meg</div>
                    </div>
                  </div>
                </div>

                {/* Doboz arnyeka (alul) */}
                <div style={{ position:"absolute", bottom:-14, left:"4%", right:"4%", height:26, background:"rgba(0,0,0,.55)", borderRadius:"50%", filter:"blur(13px)", opacity:isHov?.82:.28, transition:"opacity .55s" }}/>

                {/* Keretszegely */}
                <div style={{ position:"absolute", inset:0, border:"1px solid rgba(201,165,90,"+(isHov?.28:.08)+")", transition:"border-color .5s", pointerEvents:"none", zIndex:9 }}/>

                {/* Hullo szirmok */}
                <FallingSparks active={isHov} colors={prod.petalColors}/>
              </div>

              {/* TERMEK INFO */}
              <div style={{ textAlign:"center", marginTop:26, width:cardW }}>
                <h3 style={{ fontFamily:"Georgia,serif", fontSize:mob?17:20, fontWeight:400, color:isHov?V.cream:"rgba(253,250,246,.4)", marginBottom:6, letterSpacing:.3, transition:"color .45s" }}>
                  {prod.name}
                </h3>
                <div style={{ fontSize:10, color:"rgba(253,250,246,.26)", letterSpacing:1.5, textTransform:"uppercase", marginBottom:14 }}>{prod.sub}</div>

                <div style={{ display:"flex", justifyContent:"center", flexWrap:"wrap", gap:5, marginBottom:12, opacity:isHov?1:0, transform:isHov?"none":"translateY(5px)", transition:"opacity .35s .12s, transform .35s .12s" }}>
                  {prod.tags.map(t=>(
                    <span key={t} style={{ fontSize:8, letterSpacing:1.5, textTransform:"uppercase", color:"rgba(201,165,90,.78)", border:"1px solid rgba(201,165,90,.18)", padding:"3px 8px" }}>{t}</span>
                  ))}
                </div>

                <p style={{ fontSize:12, color:"rgba(253,250,246,.26)", lineHeight:1.8, maxWidth:220, margin:"0 auto 18px", opacity:isHov?1:0, transition:"opacity .4s .18s" }}>{prod.desc}</p>

                <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:14 }}>
                  <span style={{ fontFamily:"Georgia,serif", fontSize:21, color:isHov?V.rose:"rgba(253,250,246,.3)", transition:"color .4s" }}>{fmt(prod.price)}</span>
                  <button onClick={()=>setTab("termékek")} style={{ background:isHov?V.rose:"transparent", color:isHov?V.cream:"rgba(253,250,246,.14)", border:"1px solid "+(isHov?V.rose:"rgba(253,250,246,.07)"), padding:"10px 20px", fontSize:9, letterSpacing:2.5, textTransform:"uppercase", fontWeight:700, cursor:"pointer", transition:"all .4s" }}>
                    Megnezem
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* CTA */}
      <div style={{ textAlign:"center", marginTop:60, position:"relative", zIndex:3 }}>
        <button onClick={()=>setTab("termékek")} style={{ background:"none", border:"none", fontSize:11, letterSpacing:2, textTransform:"uppercase", color:"rgba(201,165,90,.34)", cursor:"pointer", fontWeight:600, borderBottom:"1px solid rgba(201,165,90,.13)", paddingBottom:2, transition:"color .2s" }}
          onMouseEnter={e=>e.currentTarget.style.color=V.gold}
          onMouseLeave={e=>e.currentTarget.style.color="rgba(201,165,90,.34)"}
        >
          Osszes termek megtekintese
        </button>
      </div>
    </section>
  );
}

function Products({ go }) {
  const { addItem } = useCart();
  const [sort, setSort]       = useState("new");
  const [filter, setFilter]   = useState("");
  const [search, setSearch]   = useState("");
  const [activeGroup, setActiveGroup] = useState(""); // "" = minden csoport
  const w = useW(); const mob = w < 700;

  // Dinamikus csoportlista a termekekbol
  const allGroups = [...new Set(PRODS.map(p => p.group).filter(Boolean))];

  let list = [...PRODS];
  if (activeGroup) list = list.filter(p => p.group === activeGroup);
  if (filter) list = list.filter(p => p.shape === filter || p.finish === filter);
  if (search) list = list.filter(p => p.name.toLowerCase().includes(search.toLowerCase()) || p.sub.toLowerCase().includes(search.toLowerCase()));
  if (sort === "asc")  list.sort((a,b) => a.price - b.price);
  if (sort === "desc") list.sort((a,b) => b.price - a.price);
  return (
    <section style={{background:V.cream,padding:"clamp(52px,8vw,80px) clamp(16px,4vw,72px)"}}>
      <div style={{maxWidth:1280,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
          <div style={{width:28,height:1,background:V.gold}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Kollekci{"ó"}</span>
        </div>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,44px)",fontWeight:400,color:V.dark,marginBottom:24}}>
          {"Aktu\u00e1lis "}<em style={{color:V.rose,fontStyle:"italic"}}>{"kollekci\u00f3"}</em>
        </h2>
        {/* Kereso */}
        <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Keresés a termékek kozott..."
            style={{flex:1,minWidth:200,background:"white",border:"1px solid "+V.border,padding:"10px 16px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
          {search && <button onClick={()=>setSearch("")} style={{background:"none",border:"1px solid "+V.border,color:V.muted,padding:"10px 14px",cursor:"pointer",fontSize:12}}>x Torles</button>}
          {search && <span style={{fontSize:12,color:V.muted}}>{list.length} termek talalhato</span>}
        </div>

        {/* Csoport szuro gombok */}
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:28,overflowX:"auto",paddingBottom:4}}>
          <button onClick={()=>setActiveGroup("")} style={{
            background:activeGroup===""?V.dark:"transparent",
            color:activeGroup===""?V.cream:V.muted,
            border:"1px solid "+(activeGroup===""?V.dark:V.border),
            padding:"7px 16px",fontSize:10,letterSpacing:2,
            textTransform:"uppercase",fontWeight:activeGroup===""?700:500,
            cursor:"pointer",transition:"all .2s",whiteSpace:"nowrap",
          }}>Osszes</button>
          {allGroups.map(g => (
            <button key={g} onClick={()=>setActiveGroup(g===activeGroup?"":g)} style={{
              background:activeGroup===g?V.rose:"transparent",
              color:activeGroup===g?V.cream:V.muted,
              border:"1px solid "+(activeGroup===g?V.rose:V.border),
              padding:"7px 16px",fontSize:10,letterSpacing:2,
              textTransform:"uppercase",fontWeight:activeGroup===g?700:500,
              cursor:"pointer",transition:"all .2s",whiteSpace:"nowrap",
            }}>{g}</button>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax("+(mob?152:200)+"px,1fr))",gap:"clamp(12px,2vw,20px)"}}>
          {PRODS.map(p => (
            <div key={p.id} style={{background:V.ivory,cursor:"pointer",transition:"box-shadow .3s,transform .3s",boxShadow:"0 2px 12px rgba(192,68,90,.06)"}}
              onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 12px 40px rgba(192,68,90,.16)";e.currentTarget.style.transform="translateY(-5px)";}}
              onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 2px 12px rgba(192,68,90,.06)";e.currentTarget.style.transform="none";}}>
              <div style={{aspectRatio:"1",background:p.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:52,position:"relative"}}>
                {p.e}
                {p.badge && <span style={{position:"absolute",top:8,left:8,background:p.badge==="Akcio"?V.gold:V.rose,color:V.cream,fontSize:8,letterSpacing:2,textTransform:"uppercase",padding:"3px 7px",fontWeight:700}}>{p.badge}</span>}
                {p.stock < 5 && <span style={{position:"absolute",bottom:8,right:8,background:"rgba(253,250,246,.9)",color:V.rose,fontSize:8,padding:"3px 7px",fontWeight:700}}>Csak {p.stock} db!</span>}
              </div>
              <div style={{padding:"14px 16px 18px"}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:400,color:V.dark,marginBottom:4}}>{p.name}</div>
                <div style={{fontSize:10,color:V.muted,marginBottom:10,letterSpacing:.5}}>{p.sub}</div>
                <div style={{display:"flex",alignItems:"baseline",gap:8,marginBottom:12}}>
                  {p.compare && <span style={{textDecoration:"line-through",color:V.muted,fontSize:12}}>{fmt(p.compare)}</span>}
                  <span style={{fontFamily:"Georgia,serif",fontSize:17,color:V.rose}}>{fmt(p.price)}</span>
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button
                    onClick={e=>{e.stopPropagation();addItem(p,p.sizes[2]||p.sizes[0]||null,1);}}
                    disabled={p.stock===0}
                    style={{flex:1,background:p.stock===0?"#ccc":V.rose,color:V.cream,border:"none",padding:"9px 6px",fontSize:9,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,cursor:p.stock===0?"not-allowed":"pointer",transition:"opacity .2s"}}
                  >{p.stock===0?"Elfogyott":"Kosárba"}</button>
                  <button
                    onClick={e=>{e.stopPropagation();go&&go("termek-"+p.slug);}}
                    style={{background:"transparent",color:V.dark,border:"1px solid "+V.border,padding:"9px 10px",fontSize:9,letterSpacing:1,textTransform:"uppercase",fontWeight:600,cursor:"pointer"}}
                  >{">"}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// --- ROSSAKERT (Rolunk) ------------------------------
function Rossakert() {
  return (
    <section style={{background:V.warm,padding:"clamp(52px,8vw,80px) clamp(16px,4vw,72px)"}}>
      <div style={{maxWidth:1100,margin:"0 auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:48,alignItems:"center"}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{width:28,height:1,background:V.gold}}/>
              <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Filozofia</span>
            </div>
            <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,42px)",fontWeight:400,color:V.dark,marginBottom:32}}>
              {"A "}<em style={{color:V.rose,fontStyle:"italic"}}>r{"ó"}zsakert</em><br/>{"elegancia"}
            </h2>
            {/* 3 utos pont bekezdesek helyett */}
            {[
              [" Minden darab egyedi","Nem gyárban készül - minden körömszett kézzel alkotott, gondosan választott színekkel és formákkal."],
              ["5 perc, szalonhatás","Press-on rendszer: pillanatok alatt felhelyezhető, tartós, és újrahasználható. Otthon, azonnal."],
              ["A te történeted","Egyedi rendelést is vállalunk – mondd el az elképzelésedet, mi elkészítjük az álmod körömszettjét."],
            ].map(([title, text], ti) => (
              <div key={title} style={{display:"flex",gap:16,marginBottom:24}}>
                <div style={{width:3,flexShrink:0,background:"linear-gradient(to bottom,"+(ti===0?"#4a7c59":ti===1?V.rose:V.gold)+",transparent)",borderRadius:2,minHeight:48}}/>
                <div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:16,color:V.dark,marginBottom:5,fontWeight:500}}>{title}</div>
                  <p style={{fontSize:13,color:V.muted,lineHeight:1.75}}>{text}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:2}}>
            {[
              {bg:"linear-gradient(135deg,#f5e8d0,#e8d5b7)",e:"rose",l:"Arany rozsa"},
              {bg:"linear-gradient(135deg,#f0e8e7,#e8c4c0)",e:"flower",l:"Babarozsa"},
              {bg:"linear-gradient(135deg,#fdf0f0,#f5d8d5)",e:"",l:"Meleg rozsa"},
              {bg:"linear-gradient(135deg,#4a1a28,#7a3040)",e:"",l:"Barsony rozsa"},
            ].map(c=>(
              <div key={c.l} style={{aspectRatio:"1",background:c.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:8,transition:"transform .3s"}}
                onMouseEnter={e=>e.currentTarget.style.transform="scale(1.03)"}
                onMouseLeave={e=>e.currentTarget.style.transform="none"}>
                <span style={{fontSize:32}}>{c.e}</span>
                <span style={{fontSize:9,letterSpacing:2,textTransform:"uppercase",color:"rgba(42,26,30,.5)",fontWeight:600}}>{c.l}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:1,background:V.border,marginTop:48}}>
          {[["Kézzel készített","Minden darab egyedi, gondos munkával"],["Francia elegancia","Párizsi stílus, magyar szenvedély"],["Rózsa inspiráció","Természetes formák, mélységi színek"],["Egyedi rendelés","Az álmod körme elkészíthető"]].map(([t,d])=>(
            <div key={t} style={{background:V.ivory,padding:"28px 24px"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,color:V.rose,marginBottom:8}}>{t}</div>
              <p style={{fontSize:13,color:V.muted,lineHeight:1.7}}>{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
// --- VELEMENYEK --------------------------------------
function Velemenyek() {
  const reviews = [
    { name:"Kovacs Anna",  text:"Elképesztően szépek! Az esküvőn mindenki megkérdezte hol csináltattam.", prod:"French Mix" },
    { name:"Toth Monika",  text:"Gyonyoru csillogas, nagyon tartos! Mar harmadszorra rendelek.",          prod:"Crystal Waves" },
    { name:"Horvath Reka", text:"Minden alkalomra tokeletes - irodai es unnepi egyarant.",               prod:"Golden Blush" },
    { name:"Szabo Petra",  text:"Pontosan olyan lett, amilyennek elképzeltem. Evi figyelmes volt végig.", prod:"Egyedi rendelés" },
  ];
  return (
    <section style={{background:V.cream,padding:"clamp(52px,8vw,80px) clamp(16px,4vw,72px)"}}>
      <div style={{maxWidth:1280,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
          <div style={{width:28,height:1,background:V.gold}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Velemenyek</span>
        </div>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,42px)",fontWeight:400,color:V.dark,marginBottom:40}}>
          {"Mit mondanak a "}<em style={{color:V.rose,fontStyle:"italic"}}>{"v\u00e1s\u00e1rl\u00f3ink"}</em>
        </h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:16}}>
          {reviews.map((r,i)=>(
            <div key={i} style={{background:V.ivory,padding:"28px 24px",borderTop:"2px solid "+V.rose}}>
              <div style={{color:V.gold,fontSize:11,letterSpacing:2,marginBottom:12}}>{""}</div>
              <p style={{fontFamily:"Georgia,serif",fontStyle:"italic",fontSize:15,color:V.dark,lineHeight:1.75,marginBottom:14}}>{r.text}</p>
              <div style={{width:20,height:1,background:V.rose,marginBottom:12}}/>
              <div style={{fontSize:13,fontWeight:600,color:V.dark}}>{r.name}</div>
              <div style={{fontSize:11,color:V.muted,marginTop:3}}>{r.prod}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// --- FOOTER ------------------------------------------

// --- CART CONTEXT ----------------------------------
const CartCtx = React.createContext(null);
function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const addItem = (prod, size, qty, color) => {
    const key = prod.id + "|" + (size||"") + "|" + (color||"");
    setItems(prev => {
      const ex = prev.find(i => i.key === key);
      if (ex) return prev.map(i => i.key===key ? {...i, qty:i.qty+qty} : i);
      return [...prev, {key, id:prod.id, name:prod.name, price:prod.price, bg:prod.bg, e:prod.e, size, color, qty}];
    });
  };
  const remove = key => setItems(p => p.filter(i => i.key!==key));
  const setQty  = (key, qty) => qty<1 ? remove(key) : setItems(p => p.map(i => i.key===key ? {...i,qty} : i));
  const clear   = () => setItems([]);
  const sub   = items.reduce((s,i) => s+i.price*i.qty, 0);
  const ship  = sub>=10000 ? 0 : 1490;
  const total = sub + ship;
  const count = items.reduce((s,i) => s+i.qty, 0);
  return <CartCtx.Provider value={{items,addItem,remove,setQty,clear,sub,ship,total,count}}>{children}</CartCtx.Provider>;
}
const useCart = () => React.useContext(CartCtx);

// --- AUTH CONTEXT ------------------------------------
const AuthCtx = React.createContext(null);
function AuthProvider({ children }) {
  const API = "https://api.evisnailart.hu/api";
  const [user, setUser]   = useState(null);
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem("evn_token") || null; } catch { return null; }
  });
  const [loading, setLoading] = useState(!!token);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(API+"/auth/me", { headers:{ Authorization:"Bearer "+token } })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => { setUser(d.user); setLoading(false); })
      .catch(() => { setToken(null); localStorage.removeItem("evn_token"); setLoading(false); });
  }, [token]);

  const login = async (email, password) => {
    const r = await fetch(API+"/auth/login", {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({ email, password })
    });
    const d = await r.json();
    if (d.token) {
      setToken(d.token);
      setUser(d.user);
      try { localStorage.setItem("evn_token", d.token); } catch {}
      return { success: true, user: d.user };
    }
    return { success: false, error: d.error || "Hibas bejelentkezés" };
  };

  const logout = () => {
    setToken(null); setUser(null);
    try { localStorage.removeItem("evn_token"); } catch {}
  };

  const isAdmin = user?.role === "admin";

  return (
    <AuthCtx.Provider value={{ user, token, login, logout, isAdmin, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}
const useAuth = () => React.useContext(AuthCtx);

// --- TOAST -----------------------------------------
let _setToast = null;
function ToastHost() {
  const [t, setT] = useState(null);
  _setToast = setT;
  if (!t) return null;
  return (
    <div style={{position:"fixed",bottom:22,right:22,background:V.dark,color:V.cream,padding:"12px 20px",fontSize:13,zIndex:9999,boxShadow:"0 8px 32px rgba(0,0,0,.3)",animation:"tsIn .25s ease",maxWidth:280,borderLeft:"3px solid "+V.rose}}>
      {t}
      <style>{"@keyframes tsIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}"}</style>
    </div>
  );
}
function toast(msg, ms) { _setToast&&_setToast(msg); setTimeout(()=>_setToast&&_setToast(null), ms||2600); }

// --- BREADCRUMB ------------------------------------
function Crumb({ items, go }) {
  return (
    <div style={{display:"flex",gap:8,alignItems:"center",fontSize:12,color:V.muted,marginBottom:28,flexWrap:"wrap"}}>
      {items.map(([label,page],i) => (
        <React.Fragment key={i}>
          {i>0 && <span style={{opacity:.4}}>/</span>}
          {page
            ? <button onClick={()=>go(page)} style={{background:"none",border:"none",color:V.muted,cursor:"pointer",fontSize:12,fontFamily:"inherit"}}>{label}</button>
            : <span style={{color:V.dark}}>{label}</span>
          }
        </React.Fragment>
      ))}
    </div>
  );
}

// --- TERMEK RESZLET --------------------------------
function ProductDetail({ slug, go }) {
  const { addItem } = useCart();
  const prod = PRODS.find(p => p.slug===slug) || PRODS[0];
  const [size, setSize]   = useState(prod.sizes[2]||null);
  const [color, setColor]   = useState(prod.colors?.[0]||null);
  const [activeImg, setActiveImg] = useState(null);
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);
  const related = PRODS.filter(p => p.id!==prod.id && p.shape===prod.shape).slice(0,3);
  const w = useW(); const mob = w<700;

  const handleAdd = () => {
    addItem(prod, size, qty, color);
    setAdded(true);
    toast(prod.name+" a kosárban!");
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div style={{maxWidth:1200,margin:"0 auto",padding:"clamp(32px,6vw,60px) clamp(16px,4vw,72px)"}}>
      <Crumb items={[["Főoldal","home"],["Kollekció","termékek"],[prod.name,null]]} go={go}/>
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:"clamp(28px,5vw,72px)",alignItems:"start",marginBottom:64}}>
        {/* Kep */}
        <div style={{position:"sticky",top:88}}>
          {/* Fo kep vagy emoji ha nincs foto */}
          {prod.images && prod.images.length > 0 ? (
            <div>
              <div style={{aspectRatio:"1",background:prod.bg,overflow:"hidden",position:"relative"}}>
                <img src={activeImg||prod.images[0]} alt={prod.name}
                  style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                {prod.badge && <span style={{position:"absolute",top:14,left:14,background:prod.badge==="Akcio"?V.gold:V.rose,color:V.cream,fontSize:9,letterSpacing:2,textTransform:"uppercase",padding:"5px 10px",fontWeight:700}}>{prod.badge}</span>}
              </div>
              {prod.images.length > 1 && (
                <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
                  {prod.images.map((img,i) => (
                    <div key={i} onClick={()=>setActiveImg(img)}
                      style={{width:72,height:72,overflow:"hidden",cursor:"pointer",border:"2px solid "+(activeImg===img||(!activeImg&&i===0)?V.rose:V.border),flexShrink:0}}>
                      <img src={img} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div style={{aspectRatio:"1",background:prod.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:120,position:"relative",overflow:"hidden"}}>
              {prod.e}
              <div style={{position:"absolute",top:0,left:0,right:0,height:"40%",background:"linear-gradient(180deg,rgba(255,255,255,.09),transparent)",pointerEvents:"none"}}/>
              {prod.badge && <span style={{position:"absolute",top:14,left:14,background:prod.badge==="Akcio"?V.gold:V.rose,color:V.cream,fontSize:9,letterSpacing:2,textTransform:"uppercase",padding:"5px 10px",fontWeight:700}}>{prod.badge}</span>}
            </div>
          )}
          {/* Termek jellemzok */}
          {(prod.shape||prod.finish) && (
            <div style={{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}}>
              {prod.shape && <span style={{fontSize:10,background:V.warm,padding:"4px 10px",letterSpacing:1.5,textTransform:"uppercase",color:V.muted}}>{prod.shape}</span>}
              {prod.finish && <span style={{fontSize:10,background:V.warm,padding:"4px 10px",letterSpacing:1.5,textTransform:"uppercase",color:V.muted}}>{prod.finish}</span>}
            </div>
          )}
        </div>
        {/* Info */}
        <div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
            <div style={{width:20,height:1,background:V.gold}}/>
            <span style={{fontSize:9,letterSpacing:3,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Rose Garden</span>
          </div>
          <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,42px)",fontWeight:400,color:V.dark,lineHeight:1.07,marginBottom:10}}>{prod.name}</h1>
          <p style={{fontSize:13,color:V.muted,marginBottom:20,letterSpacing:.3}}>{prod.sub}</p>
          {/* Ar */}
          <div style={{display:"flex",alignItems:"baseline",gap:10,marginBottom:24}}>
            {prod.compare && <span style={{textDecoration:"line-through",color:V.muted,fontSize:16}}>{fmt(prod.compare)}</span>}
            <span style={{fontFamily:"Georgia,serif",fontSize:32,color:V.rose}}>{fmt(prod.price)}</span>
            {prod.compare && <span style={{fontSize:10,background:V.rose,color:"#fff",padding:"3px 8px",fontWeight:700}}>-{Math.round((prod.compare-prod.price)/prod.compare*100)}%</span>}
          </div>
          {/* Szin valaszto - ha van szinvariacio */}
          {prod.colors && prod.colors.length > 0 && (
            <div style={{marginBottom:22}}>
              <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:10}}>
                Szin {color && <span style={{color:V.rose,fontWeight:700}}> -  {color}</span>}
              </div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {prod.colors.map(col => (
                  <button key={col} onClick={()=>setColor(col)} style={{
                    padding:"8px 16px",
                    border:"1px solid "+(color===col?V.dark:V.border),
                    background:color===col?V.dark:"transparent",
                    color:color===col?V.cream:V.dark,
                    fontSize:12,fontWeight:color===col?700:400,
                    cursor:"pointer",transition:"all .2s",
                  }}>{col}</button>
                ))}
              </div>
            </div>
          )}

          <div style={{height:1,background:V.border,marginBottom:24}}/>
          {/* Meret */}
          {prod.sizes.length>0 && (
            <div style={{marginBottom:22}}>
              <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:10}}>Meret</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {prod.sizes.map(s => (
                  <button key={s} onClick={()=>setSize(s)} style={{width:44,height:44,border:"1px solid "+(size===s?V.dark:V.border),background:size===s?V.dark:"transparent",color:size===s?V.cream:V.dark,fontSize:12,fontWeight:600,cursor:"pointer",transition:"all .2s"}}>{s}</button>
                ))}
              </div>
            </div>
          )}
          {/* Mennyiseg */}
          <div style={{marginBottom:22}}>
            <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:10}}>Mennyiseg</div>
            <div style={{display:"flex",alignItems:"center",border:"1px solid "+V.border,width:"fit-content"}}>
              <button onClick={()=>setQty(q=>Math.max(1,q-1))} style={{width:40,height:40,background:"none",border:"none",fontSize:18,color:V.dark,cursor:"pointer",fontFamily:"inherit"}}>-</button>
              <span style={{width:40,textAlign:"center",fontSize:15,fontWeight:500}}>{qty}</span>
              <button onClick={()=>setQty(q=>Math.min(prod.stock,q+1))} style={{width:40,height:40,background:"none",border:"none",fontSize:18,color:V.dark,cursor:"pointer",fontFamily:"inherit"}}>+</button>
            </div>
          </div>
          {/* Gombok */}
          <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
            <button onClick={handleAdd} disabled={prod.stock===0} style={{flex:1,minWidth:160,background:added?V.deep:V.rose,color:V.cream,border:"none",padding:"15px 24px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:prod.stock===0?"not-allowed":"pointer",opacity:prod.stock===0?.5:1,transition:"background .3s"}}>
              {prod.stock===0?"Elfogyott":added?"Kosárban!":"Kosárba teszem"}
            </button>
            <button onClick={()=>go("kosár")} style={{background:"none",border:"1px solid "+V.border,color:V.dark,padding:"15px 20px",fontSize:11,letterSpacing:2,textTransform:"uppercase",fontWeight:600,cursor:"pointer"}}>Kosar</button>
          </div>
          {prod.stock>0&&prod.stock<5 && <p style={{fontSize:12,color:V.rose,marginBottom:16,fontWeight:600}}>Csak {prod.stock} db maradt!</p>}
          <div style={{height:1,background:V.border,marginBottom:22}}/>
          {/* Leiras */}
          <p style={{fontSize:14,color:V.muted,lineHeight:1.9,marginBottom:24}}>{prod.desc}</p>
          {/* Szallitas info */}
          {[[" Ingyenes szállítás 10 000 Ft felett",""],["1-3 munkanap kiszállítás",""],["30 napos visszakuldesi lehetoseg",""],["Biztonságos fizetés",""]].map(([t])=>(
            <div key={t} style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
              <div style={{width:5,height:5,borderRadius:"50%",background:"#4a7c59",flexShrink:0}}/>
              <span style={{fontSize:13,color:V.muted}}>{t}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Kapcsolodo termekek */}
      {related.length>0 && (
        <div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
            <div style={{width:24,height:1,background:V.gold}}/>
            <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Kapcsolodo termekek</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:16}}>
            {related.map(p=>(
              <div key={p.id} onClick={()=>go("termek-"+p.slug)} style={{background:V.ivory,cursor:"pointer",transition:"transform .3s"}}
                onMouseEnter={e=>e.currentTarget.style.transform="translateY(-4px)"}
                onMouseLeave={e=>e.currentTarget.style.transform="none"}>
                <div style={{aspectRatio:"1",background:p.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:40}}>{p.e}</div>
                <div style={{padding:"10px 12px 14px"}}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:14,color:V.dark,marginBottom:4}}>{p.name}</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:15,color:V.rose}}>{fmt(p.price)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// --- KOSAR -----------------------------------------
function CartPage({ go }) {
  const { items, remove, setQty, sub, ship, total } = useCart();
  const [coupon, setCoupon] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const discount = couponApplied ? Math.round(sub*0.1) : 0;
  const finalTotal = sub - discount + ship;
  const w = useW(); const mob = w<700;

  if (!items.length) return (
    <div style={{textAlign:"center",padding:"clamp(60px,10vw,100px) 24px"}}>
      <div style={{fontSize:64,marginBottom:20,opacity:.15}}>{""}</div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:28,fontWeight:400,color:V.dark,marginBottom:10}}>A kosar ures</h2>
      <p style={{color:V.muted,marginBottom:28,fontSize:14}}>Fedezd fel a r{"ó"}zsakert kollekci{"ó"}t!</p>
      <button onClick={()=>go("termékek")} style={{background:V.rose,color:V.cream,border:"none",padding:"14px 32px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Kollekci{"ó"} megtekint{"é"}se</button>
    </div>
  );

  return (
    <div style={{maxWidth:1100,margin:"0 auto",padding:"clamp(32px,6vw,60px) clamp(16px,4vw,72px)"}}>
      <Crumb items={[["Főoldal","home"],["Kosár",null]]} go={go}/>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
        <div style={{width:24,height:1,background:V.gold}}/>
        <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Vasarlas</span>
      </div>
      <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,40px)",fontWeight:400,color:V.dark,marginBottom:8}}>Kosaram</h1>
      <p style={{color:V.muted,marginBottom:36,fontSize:13}}>{items.reduce((s,i)=>s+i.qty,0)} termek</p>

      <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr clamp(260px,32%,340px)",gap:36,alignItems:"start"}}>
        {/* Termekek */}
        <div>
          {items.map(item => (
            <div key={item.key} style={{display:"grid",gridTemplateColumns:"80px 1fr auto",gap:16,padding:"20px 0",borderBottom:"1px solid "+V.border,alignItems:"center"}}>
              <div style={{width:80,height:80,background:item.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,flexShrink:0}}>{item.e}</div>
              <div>
                <div style={{fontFamily:"Georgia,serif",fontSize:16,color:V.dark,marginBottom:3}}>{item.name}</div>
                {item.size && <div style={{fontSize:11,color:V.muted,marginBottom:3}}>Meret: {item.size}</div>}
              {item.color && <div style={{fontSize:11,color:V.muted,marginBottom:5}}>Szin: {item.color}</div>}
                <div style={{fontFamily:"Georgia,serif",fontSize:16,color:V.rose,marginBottom:8}}>{fmt(item.price*item.qty)}</div>
                <div style={{display:"flex",alignItems:"center",border:"1px solid "+V.border,width:"fit-content"}}>
                  <button onClick={()=>setQty(item.key,item.qty-1)} style={{width:30,height:30,background:"none",border:"none",fontSize:16,cursor:"pointer",color:V.dark,fontFamily:"inherit"}}>-</button>
                  <span style={{width:30,textAlign:"center",fontSize:13,fontWeight:500}}>{item.qty}</span>
                  <button onClick={()=>setQty(item.key,item.qty+1)} style={{width:30,height:30,background:"none",border:"none",fontSize:16,cursor:"pointer",color:V.dark,fontFamily:"inherit"}}>+</button>
                </div>
              </div>
              <button onClick={()=>remove(item.key)} style={{background:"none",border:"none",fontSize:20,color:V.muted,cursor:"pointer",padding:8,lineHeight:1}}>x</button>
            </div>
          ))}
          <button onClick={()=>go("termékek")} style={{marginTop:20,background:"none",border:"none",fontSize:11,letterSpacing:2,textTransform:"uppercase",color:V.muted,cursor:"pointer",borderBottom:"1px solid "+V.border,paddingBottom:2}}>Vasarlas folytatasa</button>
        </div>

        {/* Osszesito */}
        <div style={{background:V.warm,padding:28}}>
          <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:20}}>Osszesito</div>

          <div style={{display:"flex",justifyContent:"space-between",fontSize:14,marginBottom:10}}>
            <span style={{color:V.muted}}>Reszosszeg</span>
            <span style={{fontWeight:500}}>{fmt(sub)}</span>
          </div>
          {discount>0 && (
            <div style={{display:"flex",justifyContent:"space-between",fontSize:14,marginBottom:10}}>
              <span style={{color:V.muted}}>Kedvezmeny (10%)</span>
              <span style={{color:V.rose,fontWeight:500}}>-{fmt(discount)}</span>
            </div>
          )}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:14,marginBottom:16}}>
            <span style={{color:V.muted}}>Szallitas</span>
            <span style={{color:ship===0?"#4a7c59":V.dark,fontWeight:500}}>{ship===0?"Ingyenes ":fmt(ship)}</span>
          </div>
          {ship>0 && <p style={{fontSize:11,color:"#4a7c59",marginBottom:16}}>Meg {fmt(10000-sub)} az ingyenes szallitashoz</p>}

          {/* Kupon */}
          <div style={{marginBottom:20}}>
            <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:8}}>Kupon kod</div>
            <div style={{display:"flex",gap:0}}>
              <input value={coupon} onChange={e=>setCoupon(e.target.value.toUpperCase())} placeholder="WELCOME10" style={{flex:1,background:"white",border:"1px solid "+V.border,borderRight:"none",padding:"9px 12px",fontSize:13,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
              <button onClick={()=>{if(coupon==="WELCOME10"){setCouponApplied(true);toast("Kupon alkalmazva! -10%");}else toast("Érvénytelen kupon kod.");}} style={{background:V.rose,color:V.cream,border:"none",padding:"9px 14px",fontSize:10,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>OK</button>
            </div>
          </div>

          <div style={{height:1,background:V.border,marginBottom:16}}/>
          <div style={{display:"flex",justifyContent:"space-between",fontFamily:"Georgia,serif",fontSize:22,color:V.dark,marginBottom:24}}>
            <span>Osszesen</span>
            <span style={{color:V.rose}}>{fmt(finalTotal)}</span>
          </div>
          <button onClick={()=>go("pénztár")} style={{display:"block",width:"100%",background:V.rose,color:V.cream,border:"none",padding:"15px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Tovabb a penztarhoz</button>
        </div>
      </div>
    </div>
  );
}

// --- PENZTAR ---------------------------------------
function Checkout({ go }) {
  const { items, sub, ship, total, clear } = useCart();
  const [step, setStep] = useState(0);
  const [done, setDone] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [form, setF] = useState({
    fn:"",ln:"",email:"",phone:"",
    street:"",city:"",zip:"",
    pay:"card",ship:"gls"
  });
  const set = (k,v) => setF(f=>({...f,[k]:v}));
  const w = useW(); const mob = w<700;

  if (!items.length&&!done) { go("kosár"); return null; }

  if (done) return (
    <div style={{textAlign:"center",padding:"clamp(60px,10vw,100px) 24px",maxWidth:520,margin:"0 auto"}}>
      <div style={{width:64,height:64,borderRadius:"50%",background:"#4a7c59",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 24px",fontSize:28}}>{""}</div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,marginBottom:16}}>
        <div style={{width:24,height:1,background:V.gold}}/>
        <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Rendeles</span>
        <div style={{width:24,height:1,background:V.gold}}/>
      </div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:400,color:V.dark,marginBottom:12}}>Koszonjuk a rendelest!</h2>
      <p style={{color:V.muted,marginBottom:6,fontSize:14}}>Rendelesi azonosito: <strong style={{color:V.dark,fontFamily:"monospace"}}>{"#"}{orderId}</strong></p>
      <p style={{color:V.muted,marginBottom:32,fontSize:14}}>Visszaigazolot kuldtunk az email-edre.</p>
      <div style={{background:V.warm,padding:24,marginBottom:28,textAlign:"left"}}>
        <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:14}}>Mi a kovetkezo lepes?</div>
        {[["1-3 munkanap","A csomagod elkeszul es utnak indul"],["Email ertesito","Szállítási adatokat kuldunk"],["Keznel a szett","Helyezd fel es ragyogj!"]].map(([t,d])=>(
          <div key={t} style={{display:"flex",gap:12,marginBottom:12}}>
            <div style={{width:3,background:V.rose,flexShrink:0,borderRadius:2}}/>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:V.dark}}>{t}</div>
              <div style={{fontSize:12,color:V.muted}}>{d}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
        <button onClick={()=>go("home")} style={{background:V.rose,color:V.cream,border:"none",padding:"13px 28px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Fooldal</button>
        <button onClick={()=>go("fiókom")} style={{background:"none",border:"1px solid "+V.border,color:V.dark,padding:"13px 24px",fontSize:11,letterSpacing:2,textTransform:"uppercase",fontWeight:600,cursor:"pointer"}}>Rendeleseim</button>
      </div>
    </div>
  );

  const STEPS = ["Szemelyes adatok","Szállítás","Fizetés"];
  const inp = (k, label, type, ph, required) => (
    <div style={{display:"flex",flexDirection:"column",gap:6}}>
      <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{label}{required&&" *"}</label>
      <input type={type||"text"} value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={ph||""} style={{background:"white",border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",width:"100%",fontFamily:"inherit"}}/>
    </div>
  );

  return (
    <div style={{maxWidth:960,margin:"0 auto",padding:"clamp(32px,6vw,56px) clamp(16px,4vw,72px)"}}>
      <Crumb items={[["Főoldal","home"],["Kosár","kosár"],["Pénztár",null]]} go={go}/>

      {/* Lepes indikator */}
      <div style={{display:"flex",gap:0,marginBottom:40,maxWidth:480}}>
        {STEPS.map((s,i) => (
          <div key={s} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:8,position:"relative"}}>
            {i<STEPS.length-1 && <div style={{position:"absolute",top:13,left:"calc(50% + 16px)",right:"calc(-50% + 16px)",height:1,background:i<step?V.rose:V.border}}/>}
            <div style={{width:26,height:26,borderRadius:"50%",background:i<step?V.rose:i===step?V.dark:"transparent",border:"1px solid "+(i<=step?i<step?V.rose:V.dark:V.border),display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600,color:i<=step?"#fff":V.muted,transition:"all .3s"}}>
              {i<step?"":i+1}
            </div>
            <span style={{fontSize:9,letterSpacing:1.5,textTransform:"uppercase",color:i===step?V.dark:V.muted,fontWeight:i===step?700:400}}>{s}</span>
          </div>
        ))}
      </div>

      <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr clamp(240px,34%,320px)",gap:32,alignItems:"start"}}>
        {/* Form */}
        <div style={{background:"white",padding:"clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:16}}>
          {step===0 && <>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              {inp("ln","Vezeteknev","text","Kovacs",true)}
              {inp("fn","Keresztnev","text","Anna",true)}
            </div>
            {inp("email","Email","email","anna@example.com",true)}
            {inp("phone","Telefonszam","tel","+36 30 123 4567")}
          </>}
          {step===1 && <>
            {inp("street","Utca, hazszam","text","Kossuth u. 12.",true)}
            <div style={{display:"grid",gridTemplateColumns:"130px 1fr",gap:14}}>
              {inp("zip","Iranyitoszam","text","1052",true)}
              {inp("city","Varos","text","Budapest",true)}
            </div>
            <div>
              <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:10}}>Szallitasi mod</div>
              {[{v:"gls",l:"GLS Futárszolgalat",p:"1 490 Ft",info:"1-3 munkanap"},{v:"mpl",l:"Magyar Posta",p:"1 290 Ft",info:"2-4 munkanap"},{v:"foxpost",l:"FoxPost automataba",p:"990 Ft",info:"1-2 munkanap"}].map(opt=>(
                <label key={opt.v} onClick={()=>set("ship",opt.v)} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",border:"1px solid "+(form.ship===opt.v?V.dark:V.border),cursor:"pointer",marginBottom:8,background:form.ship===opt.v?V.warm:"white",transition:"all .2s"}}>
                  <div style={{width:18,height:18,borderRadius:"50%",border:"2px solid "+(form.ship===opt.v?V.rose:V.muted),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {form.ship===opt.v && <div style={{width:8,height:8,borderRadius:"50%",background:V.rose}}/>}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:500,color:V.dark}}>{opt.l}</div>
                    <div style={{fontSize:11,color:V.muted}}>{opt.info}</div>
                  </div>
                  <div style={{fontWeight:600,color:V.dark,fontSize:13}}>{opt.p}</div>
                </label>
              ))}
            </div>
          </>}
          {step===2 && (
            <div>
              <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:10}}>Fizetesi mod</div>
              {[{v:"card",l:"Bankkartyas fizetés",info:"Visa, Mastercard, Amex"},{v:"transfer",l:"Banki atutalas",info:"Rendelést 3 napon belul kell kifizetni"},{v:"cod",l:"Utánvét",info:"Fizetéss atadaskor (+500 Ft)"}].map(opt=>(
                <label key={opt.v} onClick={()=>set("pay",opt.v)} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",border:"1px solid "+(form.pay===opt.v?V.dark:V.border),cursor:"pointer",marginBottom:8,background:form.pay===opt.v?V.warm:"white",transition:"all .2s"}}>
                  <div style={{width:18,height:18,borderRadius:"50%",border:"2px solid "+(form.pay===opt.v?V.rose:V.muted),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {form.pay===opt.v && <div style={{width:8,height:8,borderRadius:"50%",background:V.rose}}/>}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:500,color:V.dark}}>{opt.l}</div>
                    <div style={{fontSize:11,color:V.muted}}>{opt.info}</div>
                  </div>
                </label>
              ))}
              <div style={{marginTop:16,padding:16,background:V.warm,fontSize:12,color:V.muted,lineHeight:1.7}}>
                A rendeles leadasaval elfogadod az Altalanos Szerzodesi Felteteleket es az Adatvedelmi Nyilatkozatot.
              </div>
            </div>
          )}
          {/* Nav gombok */}
          <div style={{display:"flex",gap:10,justifyContent:"space-between",marginTop:8}}>
            {step>0
              ? <button onClick={()=>setStep(s=>s-1)} style={{background:"none",border:"1px solid "+V.border,color:V.dark,padding:"12px 22px",fontSize:11,letterSpacing:2,textTransform:"uppercase",fontWeight:600,cursor:"pointer"}}>Vissza</button>
              : <div/>
            }
            {step<2
              ? <button onClick={()=>{if(step===0&&(!form.fn||!form.ln||!form.email)){toast("Kerjuk toltsd ki a kotelezo mezokat!");return;}setStep(s=>s+1);}} style={{background:V.rose,color:V.cream,border:"none",padding:"12px 28px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Tovabb</button>
              : <button onClick={async ()=>{
                try {
                  const res = await fetch(API_URL+"/orders", {
                    method:"POST",
                    headers:{"Content-Type":"application/json"},
                    body: JSON.stringify({
                      customerInfo: { name: form.ln+" "+form.fn, email: form.email, phone: form.phone },
                      shippingAddress: { name: form.ln+" "+form.fn, street: form.street, city: form.city, zip: form.zip },
                      items: items.map(i => ({ slug: i.id.replace("p",""), name: i.name, price: i.price, size: i.size||null, qty: i.qty })),
                      payment: { method: form.pay },
                      shipping: { carrier: form.ship },
                      couponCode: couponApplied ? "WELCOME10" : null,
                    })
                  });
                  const data = await res.json();
                  if (data.orderNumber) { clear(); setOrderId(data.orderNumber); setDone(true); }
                  else { toast("Hiba a rendelés leadasanal. Probald ujra!"); }
                } catch(e) { toast("Kapcsolódási hiba. Ellenorizd az internetkapcsolatod!"); }
              }} style={{background:V.rose,color:V.cream,border:"none",padding:"12px 28px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Rendeles leadasa</button>
            }
          </div>
        </div>

        {/* Osszegzes oldalsav */}
        <div style={{background:V.warm,padding:24}}>
          <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:16}}>Rendelesi osszegzes</div>
          {items.map(i=>(
            <div key={i.key} style={{display:"flex",gap:10,alignItems:"center",marginBottom:12}}>
              <div style={{width:44,height:44,background:i.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{i.e}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,color:V.dark,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.name}</div>
                <div style={{fontSize:11,color:V.muted}}>{i.qty} db{i.size?"  .  "+i.size:""}{i.color?"  .  "+i.color:""}</div>
              </div>
              <div style={{fontSize:13,fontWeight:600,color:V.dark,flexShrink:0}}>{fmt(i.price*i.qty)}</div>
            </div>
          ))}
          <div style={{height:1,background:V.border,margin:"14px 0"}}/>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:V.muted,marginBottom:8}}><span>Reszosszeg</span><span>{fmt(sub)}</span></div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:V.muted,marginBottom:12}}><span>Szallitas</span><span style={{color:ship===0?"#4a7c59":V.dark}}>{ship===0?"Ingyenes ":fmt(ship)}</span></div>
          <div style={{display:"flex",justifyContent:"space-between",fontFamily:"Georgia,serif",fontSize:20,color:V.dark}}><span>Osszesen</span><span style={{color:V.rose}}>{fmt(total)}</span></div>
        </div>
      </div>
    </div>
  );
}

// --- FIOKOM ----------------------------------------
function Account({ go }) {
  const { user, login: authLogin, logout, loading } = useAuth();
  const [tab, setTab] = useState("orders");
  const [em, setEm]   = useState("");
  const [pw, setPw]   = useState("");
  const [err, setErr] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  const w = useW(); const mob = w < 600;

  const login = async () => {
    if (!em || !pw) { setErr("Kérjük add meg az adataidat!"); return; }
    setLoggingIn(true); setErr("");
    const result = await authLogin(em, pw);
    if (!result.success) setErr(result.error || "Hibas email vagy jelszó!");
    setLoggingIn(false);
  };

  if (loading) return <div style={{textAlign:"center",padding:"80px 24px",color:V.muted}}>Betoltes...</div>;

  if (!user) return (
    <div style={{maxWidth:440,margin:"0 auto",padding:"clamp(52px,8vw,80px) clamp(16px,4vw,24px)"}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
        <div style={{width:24,height:1,background:V.gold}}/>
        <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Fiokom</span>
      </div>
      <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,34px)",fontWeight:400,color:V.dark,marginBottom:6}}>Bejelentkezes</h1>
      <p style={{fontSize:13,color:V.muted,marginBottom:28}}>Demo: barmilyen email + min. 4 karakter jelszo</p>
      <div style={{background:"white",padding:"clamp(22px,5vw,36px)",display:"flex",flexDirection:"column",gap:14}}>
        {[["Email","email",em,setEm,"anna@example.com"],["Jelszó","password",pw,setPw,""]].map(([l,t,v,fn,ph])=>(
          <div key={l} style={{display:"flex",flexDirection:"column",gap:6}}>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{l}</label>
            <input type={t} value={v} onChange={e=>fn(e.target.value)} onKeyDown={e=>e.key==="Enter"&&login()} placeholder={ph} style={{background:"white",border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
          </div>
        ))}
        {err && <p style={{fontSize:12,color:V.rose,fontWeight:500}}>{err}</p>}
        <button onClick={login} disabled={loggingIn} style={{background:loggingIn?"#ccc":V.rose,color:V.cream,border:"none",padding:"14px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:loggingIn?"not-allowed":"pointer",marginTop:4}}>{loggingIn?"Bejelentkezés...":"Bejelentkezés"}</button>
        <div style={{textAlign:"center"}}>
          <button style={{background:"none",border:"none",fontSize:12,color:V.muted,cursor:"pointer",textDecoration:"underline"}}>Elfelejtett jelszo</button>
        </div>
      </div>
    </div>
  );

  const ORDERS = [
    {id:"EVN-48291",date:"2025-02-10",total:9980,status:"delivered",items:["French Mix (M)","Nail Glue Pro"]},
    {id:"EVN-52103",date:"2025-03-14",total:4990,status:"shipped",items:["Golden Blush Elegance (S)"]},
    {id:"EVN-57298",date:"2025-04-20",total:7480,status:"processing",items:["Crystal Waves (M)","Nail Prep Kit"]},
  ];
  const STATUS = {delivered:{l:"Kezbesitve",c:"#155724",bg:"#d4edda"},shipped:{l:"Szállítás alatt",c:"#004085",bg:"#cce5ff"},processing:{l:"Feldolgozas",c:"#856404",bg:"#fff3cd"}};
  const TABS = [["orders","Rendeléseim"],["profile","Profil"],["addresses","Címeim"],["security","Biztonság"]];

  return (
    <div style={{maxWidth:920,margin:"0 auto",padding:"clamp(32px,6vw,60px) clamp(16px,4vw,72px)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:32,flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
            <div style={{width:24,height:1,background:V.gold}}/>
            <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Fiokom</span>
          </div>
          <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:400,color:V.dark}}>{user?.name ? "Üdv, "+user.name+"!" : "Üdv!"}</h1>
        </div>
        <button onClick={()=>logout()} style={{background:"none",border:"1px solid "+V.border,color:V.muted,padding:"8px 16px",fontSize:11,letterSpacing:2,textTransform:"uppercase",cursor:"pointer"}}>Kilepes</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"clamp(140px,22%,190px) 1fr",gap:28,alignItems:"start"}}>
        {/* Nav */}
        <div>
          {TABS.map(([k,l])=>(
            <button key={k} onClick={()=>setTab(k)} style={{display:"block",width:"100%",textAlign:"left",padding:"12px 14px",background:tab===k?V.dark:"transparent",color:tab===k?V.cream:V.muted,border:"none",fontSize:11,letterSpacing:1.5,textTransform:"uppercase",fontWeight:600,marginBottom:2,cursor:"pointer",borderLeft:"3px solid "+(tab===k?V.rose:"transparent"),transition:"all .2s"}}>{l}</button>
          ))}
        </div>
        {/* Tartalom */}
        <div>
          {tab==="orders" && (
            <div>
              <h2 style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:400,color:V.dark,marginBottom:20}}>Rendeleseim</h2>
              {ORDERS.map(o=>{
                const st = STATUS[o.status];
                return (
                  <div key={o.id} style={{background:"white",padding:"20px 24px",marginBottom:12,borderLeft:"3px solid "+V.rose}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8,marginBottom:10}}>
                      <div>
                        <div style={{fontFamily:"monospace",fontSize:13,color:V.dark,fontWeight:600}}>{"#"}{o.id}</div>
                        <div style={{fontSize:12,color:V.muted,marginTop:2}}>{o.date}</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <span style={{fontSize:10,letterSpacing:1.5,textTransform:"uppercase",padding:"4px 10px",fontWeight:700,background:st.bg,color:st.c}}>{st.l}</span>
                        <div style={{fontFamily:"Georgia,serif",fontSize:16,color:V.rose,marginTop:6}}>{fmt(o.total)}</div>
                      </div>
                    </div>
                    <div style={{fontSize:12,color:V.muted}}>{o.items.join("  .  ")}</div>
                  </div>
                );
              })}
            </div>
          )}
          {tab==="profile" && (
            <div>
              <h2 style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:400,color:V.dark,marginBottom:20}}>Profil adatok</h2>
              <div style={{background:"white",padding:"clamp(18px,4vw,28px)",display:"flex",flexDirection:"column",gap:14}}>
                {[["Teljes nev","Kovacs Anna"],["Email","anna@example.com"],["Telefonszam","+36 20 123 4567"]].map(([l,v])=>(
                  <div key={l} style={{display:"flex",flexDirection:"column",gap:6}}>
                    <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{l}</label>
                    <input defaultValue={v} style={{background:"white",border:"1px solid "+V.border,padding:"10px 13px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
                  </div>
                ))}
                <button onClick={()=>toast("Profil mentve!")} style={{alignSelf:"flex-start",background:V.rose,color:V.cream,border:"none",padding:"11px 24px",fontSize:11,letterSpacing:2,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Mentes</button>
              </div>
            </div>
          )}
          {tab==="addresses" && (
            <div>
              <h2 style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:400,color:V.dark,marginBottom:20}}>Cimeim</h2>
              <div style={{background:"white",padding:"20px 24px",borderLeft:"3px solid "+V.rose,marginBottom:12}}>
                <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.gold,fontWeight:600,marginBottom:8}}>Alapertelmezett</div>
                <div style={{fontSize:14,color:V.dark,lineHeight:1.7}}>Kovacs Anna<br/>1052 Budapest, Kossuth u. 12.<br/>+36 20 123 4567</div>
              </div>
              <button onClick={()=>toast("Cim hozzaadva!")} style={{background:"none",border:"1px solid "+V.border,color:V.dark,padding:"10px 20px",fontSize:11,letterSpacing:2,textTransform:"uppercase",cursor:"pointer"}}>+ Uj cim</button>
            </div>
          )}
          {tab==="security" && (
            <div>
              <h2 style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:400,color:V.dark,marginBottom:20}}>Jelszovaltoztatas</h2>
              <div style={{background:"white",padding:"clamp(18px,4vw,28px)",display:"flex",flexDirection:"column",gap:14,maxWidth:360}}>
                {["Jelenlegi jelszó","Új jelszó","Új jelszó megismetve"].map(l=>(
                  <div key={l} style={{display:"flex",flexDirection:"column",gap:6}}>
                    <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{l}</label>
                    <input type="password" placeholder="..." style={{background:"white",border:"1px solid "+V.border,padding:"10px 13px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
                  </div>
                ))}
                <button onClick={()=>toast("Jelszó megvaltoztatva!")} style={{alignSelf:"flex-start",background:V.rose,color:V.cream,border:"none",padding:"11px 24px",fontSize:11,letterSpacing:2,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Mentes</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


// --- HIRLEVEL OLDAL ----------------------------------
function NewsletterPage() {
  const [email, setEmail]   = useState("");
  const [name, setName]     = useState("");
  const [prefs, setPrefs]   = useState([]);
  const [done, setDone]     = useState(false);
  const [err, setErr]       = useState("");
  const w = useW(); const mob = w < 600;

  const TOPICS = [
    { id:"new",     label:"Új kollekció",        icon:"" },
    { id:"sale",    label:"Akciok, levarazasok",  icon:"" },
    { id:"tips",    label:"Kormapolas tippek",     icon:"" },
    { id:"custom",  label:"Egyedi rendelés hirek", icon:"" },
    { id:"club",    label:"Korom Klub ujdonsagok", icon:"" },
  ];

  const toggle = id => setPrefs(p =>
    p.includes(id) ? p.filter(x => x!==id) : [...p, id]
  );

  const submit = () => {
    if (!email.includes("@")) { setErr("Kerlek adj meg egy ervenyes email cimet!"); return; }
    setErr("");
    setDone(true);
    toast("Sikeresen feliratkoztal! Elso levelunk hamarosan erkezik.");
  };

  if (done) return (
    <div style={{minHeight:"60vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"40px 20px"}}>
      <div style={{textAlign:"center",maxWidth:480}}>
        <div style={{fontSize:56,marginBottom:20}}>{""}</div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,marginBottom:16}}>
          <div style={{width:28,height:1,background:V.gold}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Koszonjuk</span>
          <div style={{width:28,height:1,background:V.gold}}/>
        </div>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:400,color:V.dark,marginBottom:12}}>
          {"Ü"}dv a r{"ó"}zsakertben!
        </h2>
        <p style={{fontSize:14,color:V.muted,lineHeight:1.9,marginBottom:8}}>
          A <strong style={{color:V.dark}}>{email}</strong> cimre hamarosan kuldjuk az elso levelunket.
        </p>
        <p style={{fontSize:13,color:V.muted,lineHeight:1.8,marginBottom:28}}>
          Ne felejtsd el megnezni a spam mappat is, es add hozza a cimet a kontaktjaidhoz hogy ne maradj le semmilyen uj kollekciorol!
        </p>
        <div style={{background:V.warm,padding:"16px 20px",marginBottom:24,textAlign:"left"}}>
          <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.gold,fontWeight:600,marginBottom:10}}>Feliratkoztal ezekre:</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {(prefs.length ? TOPICS.filter(t=>prefs.includes(t.id)) : TOPICS).map(t=>(
              <span key={t.id} style={{fontSize:11,background:V.ivory,padding:"4px 10px",color:V.dark}}>{t.icon} {t.label}</span>
            ))}
          </div>
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
          <button onClick={()=>window.location.reload()} style={{background:"none",border:"1px solid "+V.border,color:V.dark,padding:"11px 22px",fontSize:10,letterSpacing:2,textTransform:"uppercase",cursor:"pointer"}}>Uj feliratkozas</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{maxWidth:700,margin:"0 auto",padding:"clamp(40px,6vw,72px) clamp(16px,4vw,24px)"}}>
      {/* Fejlec */}
      <div style={{textAlign:"center",marginBottom:40}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:14,marginBottom:14}}>
          <div style={{width:32,height:1,background:"linear-gradient(90deg,transparent,"+V.gold+")"}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>H{"í"}rlevel</span>
          <div style={{width:32,height:1,background:"linear-gradient(90deg,"+V.gold+",transparent)"}}/>
        </div>
        <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(28px,5vw,46px)",fontWeight:400,color:V.dark,lineHeight:1.08,marginBottom:14}}>
          {"Legy elso, aki "}<em style={{color:V.rose,fontStyle:"italic"}}>megtudja</em>
        </h1>
        <p style={{fontSize:14,color:V.muted,lineHeight:1.9,maxWidth:480,margin:"0 auto"}}>
          {"Iratkozz fel hírlevelünkre és értesülj az új kollekcióról, exkluzív ajánlatokról és szezonális tippekről elsőnek."}
        </p>
      </div>

      {/* Fo kartya */}
      <div style={{background:"white",padding:"clamp(24px,5vw,40px)"}}>

        {/* Nev + email */}
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14,marginBottom:14}}>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Neved</label>
            <input
              value={name} onChange={e=>setName(e.target.value)}
              placeholder="Kovacs Anna"
              style={{background:V.ivory,border:"1px solid "+V.border,padding:"12px 14px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}
            />
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Email cimed *</label>
            <input
              value={email} onChange={e=>{setEmail(e.target.value);setErr("");}}
              placeholder="anna@example.com"
              type="email"
              style={{background:V.ivory,border:"1px solid "+(err?V.rose:V.border),padding:"12px 14px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}
            />
          </div>
        </div>
        {err && <p style={{fontSize:12,color:V.rose,marginBottom:14,fontWeight:500}}>{err}</p>}

        {/* Temavalasztas */}
        <div style={{marginBottom:24}}>
          <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:12}}>
            Mire vagy kivancsi? <span style={{color:V.muted,fontWeight:400,letterSpacing:0,textTransform:"none",fontSize:11}}>(opcionalis - vagy feliratkozol mindenre)</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(3,1fr)",gap:8}}>
            {TOPICS.map(t => {
              const sel = prefs.includes(t.id);
              return (
                <button key={t.id} onClick={()=>toggle(t.id)} style={{
                  background: sel ? V.warm : "transparent",
                  border: "1px solid " + (sel ? V.rose : V.border),
                  padding:"10px 12px",
                  display:"flex", alignItems:"center", gap:8,
                  cursor:"pointer", textAlign:"left",
                  transition:"all .2s",
                }}>
                  <span style={{fontSize:16,flexShrink:0}}>{t.icon}</span>
                  <div>
                    <div style={{fontSize:11,fontWeight:sel?700:500,color:sel?V.rose:V.dark,letterSpacing:.3}}>{t.label}</div>
                  </div>
                  {sel && <span style={{marginLeft:"auto",color:V.rose,fontSize:14,flexShrink:0}}>{""}</span>}
                </button>
              );
            })}
          </div>
        </div>

        {/* GDPR */}
        <div style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:22,padding:"14px",background:V.warm}}>
          <svg width="14" height="14" viewBox="0 0 14 14" style={{flexShrink:0,marginTop:2}}>
            <circle cx="7" cy="7" r="6.5" fill="none" stroke="#4a7c59" strokeWidth="1"/>
            <text x="7" y="11" textAnchor="middle" fill="#4a7c59" fontSize="9" fontWeight="bold">i</text>
          </svg>
          <p style={{fontSize:11,color:V.muted,lineHeight:1.7}}>
            {"Az email címedet kizárólag Evi's Nail Art hírlevél küldésre használjuk. Bármikor leiratkozhatsz egy kattintással. Adataidat harmadik félnek nem adjuk át."}
          </p>
        </div>

        {/* Gomb */}
        <button onClick={submit} style={{
          display:"block", width:"100%",
          background:V.rose, color:V.cream, border:"none",
          padding:"15px", fontSize:11, letterSpacing:3,
          textTransform:"uppercase", fontWeight:700, cursor:"pointer",
          transition:"opacity .2s",
        }}>
          Feliratkozom az ujdonsagokra
        </button>

        {/* Elonyok */}
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"repeat(3,1fr)",gap:12,marginTop:24,paddingTop:20,borderTop:"1px solid "+V.border}}>
          {[["","Exkluzív előnézők","Új kollekciót előbb látod mint mások"],["","Visszavonás bármikor","Egy kattintás és törlöd magad"],["","Nulla spam","Csak értékes tartalmat küldünk"]].map(([icon,title,text])=>(
            <div key={title} style={{textAlign:"center",padding:"12px 8px"}}>
              <div style={{fontSize:22,marginBottom:6}}>{icon}</div>
              <div style={{fontSize:11,fontWeight:600,color:V.dark,marginBottom:4}}>{title}</div>
              <div style={{fontSize:11,color:V.muted,lineHeight:1.6}}>{text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// --- NEWSLETTER SZEKCIO (fooldal) --------------------
function NewsletterSection({ go }) {
  const [email, setEmail] = useState("");
  const [sent, setSent]   = useState(false);

  const submit = () => {
    if (!email.includes("@")) { toast("Kerlek adj meg ervenyes email cimet!", true); return; }
    setSent(true);
    toast("Sikeresen feliratkoztal!");
  };

  return (
    <section style={{background:"linear-gradient(135deg,"+V.dark+" 0%,#1a0a10 50%,"+V.dark+" 100%)",padding:"clamp(52px,8vw,80px) clamp(16px,4vw,72px)",position:"relative",overflow:"hidden"}}>

      {/* Hatter rozsa diszek */}
      <div style={{position:"absolute",right:"-5%",top:"50%",transform:"translateY(-50%)",width:280,height:280,opacity:.04,pointerEvents:"none"}}>
        <svg width="280" height="280" viewBox="0 0 200 200">
          <g transform="translate(100,100)">
            {[0,45,90,135,180,225,270,315].map((a,i)=>(
              <g key={i} transform={"rotate("+a+")"}>
                <ellipse cx="0" cy="-45" rx="18" ry="28" fill={V.rose}/>
              </g>
            ))}
            <circle cx="0" cy="0" r="10" fill={V.gold}/>
          </g>
        </svg>
      </div>
      <div style={{position:"absolute",left:"-3%",bottom:"-10%",width:200,height:200,opacity:.03,pointerEvents:"none"}}>
        <svg width="200" height="200" viewBox="0 0 200 200">
          <g transform="translate(100,100)">
            {[0,60,120,180,240,300].map((a,i)=>(
              <g key={i} transform={"rotate("+a+")"}>
                <ellipse cx="0" cy="-35" rx="14" ry="22" fill={V.rose}/>
              </g>
            ))}
          </g>
        </svg>
      </div>

      <div style={{maxWidth:640,margin:"0 auto",textAlign:"center",position:"relative",zIndex:2}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:14,marginBottom:16}}>
          <div style={{width:32,height:1,background:"linear-gradient(90deg,transparent,rgba(184,146,74,.6))"}}/>
          <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>H{"í"}rlevel</span>
          <div style={{width:32,height:1,background:"linear-gradient(90deg,rgba(184,146,74,.6),transparent)"}}/>
        </div>

        <h2 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,38px)",fontWeight:400,color:V.cream,lineHeight:1.1,marginBottom:10}}>
          {"\u00c9rtes\u00fclj els\u0151nek az "}<em style={{color:V.rose,fontStyle:"italic"}}>{"\u00faj dizájnokr\u00f3l"}</em>
        </h2>
        <p style={{fontSize:13,color:"rgba(253,250,246,.45)",lineHeight:1.85,marginBottom:28,maxWidth:460,margin:"0 auto 28px"}}>
          {"Exkluzív előnézők, szezonális kollekció hírek és tavaszi-őszi dizájn tippek egyenesen a postaládába."}
        </p>

        {sent ? (
          <div style={{background:"rgba(74,124,89,.15)",border:"1px solid rgba(74,124,89,.35)",padding:"18px 24px",display:"inline-flex",alignItems:"center",gap:12}}>
            <span style={{fontSize:20}}>{""}</span>
            <span style={{fontSize:13,color:"rgba(253,250,246,.7)"}}>Koszonjuk a feliratkozast! Hamarosan irunk.</span>
          </div>
        ) : (
          <div>
            <div style={{display:"flex",maxWidth:480,margin:"0 auto 16px",gap:0}}>
              <input
                value={email} onChange={e=>setEmail(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&submit()}
                placeholder="email@cimed.hu"
                type="email"
                style={{flex:1,background:"rgba(255,255,255,.08)",border:"1px solid rgba(253,250,246,.15)",borderRight:"none",padding:"13px 16px",fontSize:14,color:V.cream,outline:"none",fontFamily:"inherit"}}
              />
              <button onClick={submit} style={{background:V.rose,color:V.cream,border:"none",padding:"13px 24px",fontSize:10,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
                Feliratkozom
              </button>
            </div>
            <div style={{display:"flex",justifyContent:"center",gap:20,flexWrap:"wrap"}}>
              <span style={{fontSize:11,color:"rgba(253,250,246,.28)",display:"flex",alignItems:"center",gap:5}}>
                <span style={{color:"#4a7c59"}}>{""}</span> Spam mentes
              </span>
              <span style={{fontSize:11,color:"rgba(253,250,246,.28)",display:"flex",alignItems:"center",gap:5}}>
                <span style={{color:"#4a7c59"}}>{""}</span> Barmikor leiratkozhatsz
              </span>
              <button onClick={()=>go("hírlevel")} style={{background:"none",border:"none",fontSize:11,color:"rgba(253,250,246,.3)",cursor:"pointer",textDecoration:"underline",padding:0}}>
                {"R\u00e9szletes be\u00e1ll\u00edt\u00e1sok"}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}


// --- STATIC PAGE (ASZF, Adatvedelem) ----------------
function StaticPage({ title, go }) {
  return (
    <div style={{maxWidth:800,margin:"0 auto",padding:"clamp(40px,6vw,72px) clamp(16px,4vw,72px)"}}>
      <Crumb items={[["Főoldal","home"],[title,null]]} go={go}/>
      <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:400,color:V.dark,marginBottom:32}}>{title}</h1>
      <div style={{background:"white",padding:"clamp(24px,4vw,40px)",fontSize:14,color:V.muted,lineHeight:1.9}}>
        <p style={{marginBottom:16}}><strong style={{color:V.dark}}>Evi's Nail Art</strong>  -  Simon Norbert EV</p>
        <p style={{marginBottom:16}}>Ez az oldal tartalmat igenyel. Kerem vedd fel a kapcsolatot: <strong>info@evisnailart.hu</strong></p>
        <p>A teljes dokumentum elkeszitese folyamatban van. Jogi szoveg hozzaadasahoz keress fel egy jogaszt vagy hasznalj online ASZF generatort (pl. websitepolicies.com).</p>
      </div>
    </div>
  );
}

// --- ADMIN TERMEKFELTOLTO ----------------------------
function AdminProducts({ go }) {
  const [tab, setTab]       = useState("list");
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [msg, setMsg]       = useState("");
  const [form, setF]        = useState({
    slug:"", name:"", sub:"", desc:"", price:"", comparePrice:"",
    badge:"", stock:"10", shape:"Mandula", finish:"Fenyes",
    category:"szett", emoji:"",
    group:"", newGroup:"",
    sizes: ["XS","S","M","L","XL"],
    colors: [],
  });
  const [colorInput, setColorInput] = useState("");
  const [groups, setGroups] = useState([...DEFAULT_GROUPS]);
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const { token, isAdmin } = useAuth();
  const w = useW(); const mob = w < 600;
  if (!isAdmin) return <div style={{textAlign:"center",padding:"80px 24px"}}><h2 style={{fontFamily:"Georgia,serif",color:V.rose}}>Nincs jogosultsagod ehhez az oldalhoz.</h2></div>;

  const API = "https://api.evisnailart.hu/api";

  const loadProducts = async () => {
    try {
      const r = await fetch(API+"/admin/products", { headers:{ Authorization:"Bearer "+token } });
      const d = await r.json();
      setProducts(d.products || []);
    } catch(e) { setMsg("Betöltési hiba"); }
  };

  React.useEffect(() => { if(tab==="list") loadProducts(); }, [tab]);

  const set = (k,v) => setF(f=>({...f,[k]:v}));

  const handleImages = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    setPreviews(files.map(f => URL.createObjectURL(f)));
  };

  const toggleSize = (s) => setF(f => ({
    ...f,
    sizes: f.sizes.includes(s) ? f.sizes.filter(x=>x!==s) : [...f.sizes, s]
  }));

  const submit = async () => {
    if (!form.slug || !form.name || !form.price) {
      setMsg("Slug, név és ár kötelező!"); return;
    }
    setLoading(true); setMsg("");
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => {
        if (k === "sizes") fd.append(k, JSON.stringify(v));
        else fd.append(k, v);
      });
      images.forEach(img => fd.append("images", img));
      // Ha uj csoport lett megadva, azt hasznaljuk
      const finalGroup = form.newGroup.trim() || form.group;
      if (finalGroup) { fd.append("group", finalGroup); fd.set("group", finalGroup); }
      if (form.colors.length > 0) fd.append("colors", JSON.stringify(form.colors));

      const r = await fetch(API+"/admin/products", {
        method: "POST",
        headers: { Authorization: "Bearer "+token },
        body: fd,
      });
      const d = await r.json();
      if (d.success) {
        setMsg("Termek sikeresen létrehozva!");
        setF({ slug:"", name:"", sub:"", desc:"", price:"", comparePrice:"",
               badge:"", stock:"10", shape:"Mandula", finish:"Fenyes",
               category:"szett", emoji:"", group:"", newGroup:"",
               sizes:["XS","S","M","L","XL"], colors:[] });
        setColorInput("");
        setImages([]); setPreviews([]);
        setTimeout(() => setTab("list"), 1500);
      } else { setMsg(d.error || "Hiba tortent"); }
    } catch(e) { setMsg("Kapcsolódási hiba: "+e.message); }
    setLoading(false);
  };

  const updateStock = async (slug, stock) => {
    await fetch(API+"/admin/products/"+slug+"/stock", {
      method:"PATCH", headers:{ Authorization:"Bearer "+token, "Content-Type":"application/json" },
      body: JSON.stringify({ stock: parseInt(stock) })
    });
    loadProducts();
  };

  const inp = (k, label, type, ph, req) => (
    <div style={{display:"flex",flexDirection:"column",gap:6}}>
      <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{label}{req&&" *"}</label>
      <input type={type||"text"} value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={ph||""}
        style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit",width:"100%"}}/>
    </div>
  );

  return (
    <div style={{maxWidth:960,margin:"0 auto",padding:"clamp(32px,6vw,56px) clamp(16px,4vw,72px)"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:28,flexWrap:"wrap",gap:12}}>
        <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(22px,4vw,32px)",fontWeight:400,color:V.dark}}>
          Admin  -  <em style={{color:V.rose,fontStyle:"italic"}}>Termekek</em>
        </h1>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setTab("list")} style={{background:tab==="list"?V.dark:"transparent",color:tab==="list"?V.cream:V.dark,border:"1px solid "+V.border,padding:"9px 18px",fontSize:10,letterSpacing:2,textTransform:"uppercase",cursor:"pointer"}}>Lista</button>
          <button onClick={()=>setTab("new")} style={{background:tab==="new"?V.rose:"transparent",color:tab==="new"?V.cream:V.rose,border:"1px solid "+V.rose,padding:"9px 18px",fontSize:10,letterSpacing:2,textTransform:"uppercase",cursor:"pointer",fontWeight:700}}>+ Uj termek</button>
        </div>
      </div>

      {msg && <div style={{padding:"12px 16px",background:msg.includes("siker")?"#edf5ee":"#fef0f3",color:msg.includes("siker")?"#2d6a2d":V.rose,marginBottom:16,fontSize:13,fontWeight:500}}>{msg}</div>}

      {/* TERMEK LISTA */}
      {tab==="list" && (
        <div>
          {products.length === 0 && <p style={{color:V.muted}}>Nincsenek termekek meg.</p>}
          <div style={{display:"grid",gap:12}}>
            {products.map(p => (
              <div key={p._id} style={{background:"white",padding:"16px 20px",display:"grid",gridTemplateColumns:mob?"1fr":"60px 1fr auto auto",gap:12,alignItems:"center"}}>
                {/* Kep */}
                <div style={{width:56,height:56,background:p.bg||V.warm,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0,overflow:"hidden"}}>
                  {p.images?.[0] ? <img src={p.images[0]} alt={p.name} style={{width:"100%",height:"100%",objectFit:"cover"}}/> : p.emoji}
                </div>
                {/* Info */}
                <div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:15,color:V.dark,marginBottom:2}}>{p.name}</div>
                  <div style={{fontSize:11,color:V.muted}}>{p.slug}  .  {(p.price||0).toLocaleString("hu-HU")} Ft  .  {p.images?.length||0} kep</div>
                </div>
                {/* Keszlet */}
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:11,color:V.muted}}>Keszlet:</span>
                  <input type="number" defaultValue={p.stock} min="0"
                    style={{width:60,padding:"5px 8px",border:"1px solid "+V.border,fontSize:13,textAlign:"center"}}
                    onBlur={e=>updateStock(p.slug,e.target.value)}/>
                </div>
                {/* Aktiv badge */}
                <span style={{fontSize:9,letterSpacing:1.5,textTransform:"uppercase",padding:"4px 10px",background:p.active?"#edf5ee":"#fee",color:p.active?"#2d6a2d":"#c0445a",fontWeight:700}}>
                  {p.active?"Aktív":"Inaktív"}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* UJ TERMEK FORM */}
      {tab==="new" && (
        <div style={{background:"white",padding:"clamp(20px,4vw,36px)",display:"flex",flexDirection:"column",gap:16}}>
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
            {inp("name","Termék neve","text","pl. Black Marble Noir",true)}
            {inp("slug","URL slug","text","pl. black-marble-noir",true)}
          </div>
          {inp("sub","Alcím","text","pl. Mandula  .  Fenyes  .  Arany")}
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Leiras</label>
            <textarea value={form.desc} onChange={e=>set("desc",e.target.value)} rows={4} placeholder="Termek reszletes leírása..."
              style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",resize:"vertical",fontFamily:"inherit"}}/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14}}>
            {inp("price","Ar (Ft)","number","4990",true)}
            {inp("comparePrice","Eredeti ár (Ft)","number","5990")}
            {inp("stock","Készlet (db)","number","10")}
            {inp("emoji","Emoji","text","")}
          </div>
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(3,1fr)",gap:14}}>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Kategoria</label>
              <select value={form.category} onChange={e=>set("category",e.target.value)}
                style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none"}}>
                <option value="szett">Koromszett</option>
                <option value="kellek">Kellekek</option>
              </select>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Csoport / Kollekcio</label>
              <select value={form.group} onChange={e=>set("group",e.target.value)}
                style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none"}}>
                <option value="">-- Valassz csoportot --</option>
                {groups.map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Forma</label>
              <select value={form.shape} onChange={e=>set("shape",e.target.value)}
                style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none"}}>
                {["Mandula","Ovalis","Kerek","Szogletes","Stilett","Ballerina"].map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Felulet</label>
              <select value={form.finish} onChange={e=>set("finish",e.target.value)}
                style={{background:V.ivory,border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none"}}>
                {["Fenyes","Matt","Glitter","Gyongyhar","Hologr","Velvet"].map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          {/* Uj csoport letrehozasa */}
          <div style={{background:V.warm,padding:"14px 16px"}}>
            <div style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,marginBottom:8}}>
              Uj csoport letrehozasa (opcionalis)
            </div>
            <div style={{display:"flex",gap:8}}>
              <input value={form.newGroup} onChange={e=>set("newGroup",e.target.value)}
                placeholder="pl. Tavaszi kollekció, Eskuvoi szett..."
                style={{flex:1,background:"white",border:"1px solid "+V.border,padding:"9px 12px",fontSize:13,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
              <button type="button" onClick={()=>{
                const g = form.newGroup.trim();
                if(g && !groups.includes(g)){
                  setGroups(prev=>[...prev,g]);
                  set("group",g);
                  set("newGroup","");
                  toast("Csoport létrehozva: "+g);
                }
              }} style={{background:V.dark,color:V.cream,border:"none",padding:"9px 16px",fontSize:10,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
                + Letrehozas
              </button>
            </div>
            {form.newGroup && !groups.includes(form.newGroup.trim()) && (
              <p style={{fontSize:11,color:"#4a7c59",marginTop:6}}>Ez egy uj csoport lesz: "{form.newGroup}"</p>
            )}
            {form.newGroup && groups.includes(form.newGroup.trim()) && (
              <p style={{fontSize:11,color:V.rose,marginTop:6}}>Ez a csoport mar letezik  -  valaszd ki a listabol!</p>
            )}
          </div>

          {inp("badge","Badge (opcionális)","text","pl. Bestseller, Akcio, Uj")}

          {/* Meretek */}
          <div>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,display:"block",marginBottom:10}}>Meretek</label>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {["XS","S","M","L","XL","XXL"].map(s=>(
                <button key={s} type="button" onClick={()=>toggleSize(s)}
                  style={{width:44,height:44,border:"1px solid "+(form.sizes.includes(s)?V.dark:V.border),background:form.sizes.includes(s)?V.dark:"transparent",color:form.sizes.includes(s)?V.cream:V.dark,fontSize:12,fontWeight:600,cursor:"pointer"}}>
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* Szinvariaciok - opcionalis */}
          <div>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,display:"block",marginBottom:6}}>
              Szinvariaciok <span style={{fontWeight:400,textTransform:"none",letterSpacing:0,fontSize:11}}>(opcionalis)</span>
            </label>
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              <input
                value={colorInput}
                onChange={e=>setColorInput(e.target.value)}
                onKeyDown={e=>{
                  if(e.key==="Enter"&&colorInput.trim()){
                    setF(f=>({...f,colors:[...f.colors,colorInput.trim()]}));
                    setColorInput("");
                    e.preventDefault();
                  }
                }}
                placeholder="pl. Nude Pink, Deep Red, Champagne..."
                style={{flex:1,background:V.ivory,border:"1px solid "+V.border,padding:"10px 13px",fontSize:13,color:V.dark,outline:"none",fontFamily:"inherit"}}
              />
              <button type="button"
                onClick={()=>{
                  if(colorInput.trim()){
                    setF(f=>({...f,colors:[...f.colors,colorInput.trim()]}));
                    setColorInput("");
                  }
                }}
                style={{background:V.dark,color:V.cream,border:"none",padding:"10px 18px",fontSize:11,letterSpacing:1.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}
              >+ Hozzaad</button>
            </div>
            {form.colors.length > 0 && (
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {form.colors.map((col,i) => (
                  <div key={i} style={{display:"flex",alignItems:"center",gap:6,background:V.warm,padding:"5px 12px",fontSize:12}}>
                    <span style={{color:V.dark}}>{col}</span>
                    <button type="button" onClick={()=>setF(f=>({...f,colors:f.colors.filter((_,j)=>j!==i)}))}
                      style={{background:"none",border:"none",color:V.muted,cursor:"pointer",fontSize:14,lineHeight:1,padding:0}}>x</button>
                  </div>
                ))}
              </div>
            )}
            <p style={{fontSize:11,color:V.muted,marginTop:6}}>Enter vagy + gombbal adj hozza szint. Kattints az x-re a torleshez.</p>
          </div>

          {/* Kepfeltoltes */}
          <div>
            <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600,display:"block",marginBottom:10}}>Termekfotok (max 8 kep)</label>
            <label style={{display:"flex",alignItems:"center",gap:12,padding:"20px",border:"2px dashed "+V.border,cursor:"pointer",background:V.ivory}}>
              <span style={{fontSize:28}}></span>
              <div>
                <div style={{fontSize:14,fontWeight:500,color:V.dark}}>Kattints vagy huzd ide a kepeket</div>
                <div style={{fontSize:11,color:V.muted}}>PNG, JPG  -  max 10MB/kep  -  automatikusan optimalizaljuk</div>
              </div>
              <input type="file" multiple accept="image/*" onChange={handleImages} style={{display:"none"}}/>
            </label>
            {previews.length > 0 && (
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:12}}>
                {previews.map((src,i) => (
                  <div key={i} style={{width:80,height:80,overflow:"hidden",border:"1px solid "+V.border}}>
                    <img src={src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                  </div>
                ))}
              </div>
            )}
          </div>

          <button onClick={submit} disabled={loading}
            style={{background:loading?"#ccc":V.rose,color:V.cream,border:"none",padding:"15px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:loading?"not-allowed":"pointer",marginTop:8}}>
            {loading?"Feltöltés folyamatban...":"Termek létrehozása"}
          </button>
        </div>
      )}
    </div>
  );
}

function Footer({ setTab }) {
  const [email, setEmail] = useState("");
  return (
    <footer style={{background:V.dark,padding:"clamp(40px,6vw,60px) clamp(16px,4vw,72px) 28px"}}>
      <div style={{maxWidth:1280,margin:"0 auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:40,marginBottom:40,paddingBottom:40,borderBottom:"1px solid rgba(192,68,90,.15)"}}>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:V.cream,letterSpacing:2,marginBottom:4}}>{"Evi's Nail Art"}</div>
            <div style={{fontSize:8,letterSpacing:4,textTransform:"uppercase",color:V.gold,marginBottom:16,opacity:.7}}>Rose Garden Collection</div>
            <p style={{fontSize:12,color:"rgba(253,250,246,.4)",lineHeight:1.8}}>K{"é"}zzel k{"é"}sz{"í"}tett press-on k{"ö"}rm{"ö"}k, r{"ó"}zsa inspir{"á"}ci{"ó"}b{"ó"}l.</p>
          </div>
          {[["Kollekció",[["termékek","Összes termék"],["vélemények","Vélemények"],["egyedi","Egyedi rendelés"]]],["Info",[["rolunk","Rózsakertről"],["kosár","Kosár"]]]].map(([h,links])=>(
            <div key={h}>
              <div style={{fontSize:9,letterSpacing:3,textTransform:"uppercase",color:V.gold,marginBottom:16,fontWeight:600}}>{h}</div>
              <ul style={{listStyle:"none"}}>
                {links.map(([k,l])=><li key={k} style={{marginBottom:10}}><button onClick={()=>setTab(k)} style={{background:"none",border:"none",fontSize:12,color:"rgba(253,250,246,.4)",cursor:"pointer"}}>{l}</button></li>)}
              </ul>
            </div>
          ))}
          <div>
            <div style={{fontSize:9,letterSpacing:3,textTransform:"uppercase",color:V.gold,marginBottom:16,fontWeight:600}}>H{"í"}rlevel</div>
            <p style={{fontSize:12,color:"rgba(253,250,246,.4)",marginBottom:12}}>{"Új kollekció értesítő!"}</p>
            <div style={{display:"flex",gap:0}}>
              <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="email@cimed.hu" style={{flex:1,background:"rgba(255,255,255,.06)",border:"1px solid rgba(192,68,90,.2)",borderRight:"none",padding:"10px 12px",fontSize:13,color:V.cream,outline:"none"}}/>
              <button onClick={()=>setEmail("")} style={{background:V.rose,color:V.cream,border:"none",padding:"10px 16px",fontSize:9,letterSpacing:2,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>OK</button>
            </div>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"rgba(253,250,246,.18)",flexWrap:"wrap",gap:6}}>
          <span>{"© 2025 Evi's Nail Art  .  Simon Norbert EV"}</span>
          <span>{"  Made with love in Hungary   .   "}<button onClick={()=>go&&go("aszf")} style={{background:"none",border:"none",color:"rgba(253,250,246,.35)",cursor:"pointer",fontSize:11,textDecoration:"underline",fontFamily:"inherit"}}>ASZF</button>{"   .   "}<button onClick={()=>go&&go("adatvedelem")} style={{background:"none",border:"none",color:"rgba(253,250,246,.35)",cursor:"pointer",fontSize:11,textDecoration:"underline",fontFamily:"inherit"}}>Adatvedelmi nyilatkozat</button></span>
        </div>
      </div>
    </footer>
  );
}

// --- APP ---------------------------------------------
export default function App() {
  const [tab, setTab] = useState("home");
  const go = useCallback(t => {
    setTab(t);
    window.scrollTo({top:0, behavior:"smooth"});
  }, []);

  const getSlug = () => tab.startsWith("termek-") ? tab.slice(7) : "";

  return (
    <AuthProvider>
    <CartProvider>
    <div style={{fontFamily:"Georgia,serif",background:V.cream,color:V.dark,overflowX:"hidden",minHeight:"100vh",display:"flex",flexDirection:"column"}}>
      <RosePetals/>
      <RoseParallax/>
      <Popup/>
      <AnnounceBar/>
      <Header tab={tab} setTab={go}/>
      <div style={{position:"relative",flex:1}}>
        <main>
        {tab==="home"       && <><Hero setTab={go}/><FeaturedShowcase setTab={go}/><Products go={go}/><Rossakert/><Velemenyek/><NewsletterSection go={go}/></>}
        {tab==="termékek"   && <Products go={go}/>}
        {tab.startsWith("termek-") && <ProductDetail slug={getSlug()} go={go}/>}
        {tab==="rolunk"     && <Rossakert/>}
        {tab==="vélemények" && <Velemenyek/>}
        {tab==="kosár"      && <CartPage go={go}/>}
        {tab==="pénztár"    && <Checkout go={go}/>}
        {tab==="fiókom"     && <Account go={go}/>}
        {tab==="hírlevel"   && <NewsletterPage/>}
        {tab==="aszf"       && <StaticPage title="Általános Szerződési Feltételek" go={go}/>}
        {tab==="adatvedelem"&& <StaticPage title="Adatvédelmi Nyilatkozat" go={go}/>}
        {tab==="admin-termékek" && <AdminProducts go={go}/>}
        {tab==="egyedi"     && (
          <div style={{maxWidth:580,margin:"0 auto",padding:"clamp(52px,8vw,80px) clamp(16px,4vw,24px)"}}>
            <Crumb items={[["Főoldal","home"],["Egyedi rendelés",null]]} go={go}/>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{width:24,height:1,background:V.gold}}/>
              <span style={{fontSize:9,letterSpacing:4,textTransform:"uppercase",color:V.gold,fontWeight:600}}>Szemelyre szabva</span>
            </div>
            <h1 style={{fontFamily:"Georgia,serif",fontSize:"clamp(26px,4vw,38px)",fontWeight:400,color:V.dark,marginBottom:12}}>{"Egyedi "}<em style={{color:V.rose,fontStyle:"italic"}}>rendeles</em></h1>
            <p style={{color:V.muted,fontSize:14,lineHeight:1.9,marginBottom:32}}>Irj nekunk es egyutt alkotjuk meg almod kormszettjet! Minden igeny egyedi ajanlatot kap 24-48 oran belul.</p>
            <div style={{display:"flex",flexDirection:"column",gap:14,background:"white",padding:"clamp(20px,4vw,32px)"}}>
              {[["Neved","text","Kovacs Anna"],["Email","email","anna@example.com"],["Telefonszam","tel","+36 30 123 4567"]].map(([l,t,ph])=>(
                <div key={l} style={{display:"flex",flexDirection:"column",gap:6}}>
                  <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>{l}</label>
                  <input type={t} placeholder={ph} style={{background:"white",border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",fontFamily:"inherit"}}/>
                </div>
              ))}
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                <label style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:V.muted,fontWeight:600}}>Elkepzelesed</label>
                <textarea rows={4} placeholder="Pl: Oszi tema, bordo-arany, mandula forma, matt felulet..." style={{background:"white",border:"1px solid "+V.border,padding:"11px 13px",fontSize:14,color:V.dark,outline:"none",resize:"vertical",fontFamily:"inherit"}}/>
              </div>
              <button onClick={()=>toast("Uzenet elkuldve! 24-48 oran belul valaszolunk.")} style={{background:V.rose,color:V.cream,border:"none",padding:"14px",fontSize:11,letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,cursor:"pointer"}}>Ajanlatkeres</button>
            </div>
          </div>
        )}
      </main>
      </div>
      <Footer setTab={go}/>
      <ToastHost/>
      <style>{"*{box-sizing:border-box;margin:0;padding:0}button{cursor:pointer;font-family:inherit;transition:opacity .2s,transform .2s}button:hover{opacity:.86}button:active{transform:scale(.97)}input{font-family:inherit}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:"+V.warm+"}::-webkit-scrollbar-thumb{background:"+V.petal+";border-radius:2px}input:focus{border-color:"+V.rose+"!important}@keyframes sway0{0%,100%{transform:skewX(0deg) skewY(0deg)}50%{transform:skewX(2.5deg) skewY(1.5deg)}}@keyframes sway1{0%,100%{transform:skewX(0deg) skewY(0deg)}50%{transform:skewX(-2.5deg) skewY(-1.5deg)}}@keyframes spark0{from{stroke-dashoffset:314}to{stroke-dashoffset:0}}@keyframes sparkFade{0%,100%{opacity:0}10%,90%{opacity:1}}"}</style>
    </div>
    </CartProvider>
    </AuthProvider>
  );
}
